import { room,Video,socket,
    stopMediaPlayers, lockFocus,
    muteParticipants, bottomAction,
    convertPath, electronConfig,
    isElectron, animatedLayers, kinoParticipants, volumeManager, CONV_STORAGE, onStage, spacesView, muteAll, kinoControls, chat, screenShare, pictureInPicture, permissions, isJoined, lobby, isCameraMuted
} from './roomnew';
import sanitizeHtml from 'sanitize-html';
import axios from 'axios';
import PrivateConversation from '../room/PrivateConversation.js';
import Space from '../room/spaces/Space';
import { getLocalMainKinoTrack } from '../features/base/tracks/functions';
import { updateVideoQuality } from '../features/base/video-quality/actions';
import { allowControlClosing, controlStripOnMouseMove, hideControlStrip, preventControlFromClosing, showControlStrip, toggleControlStripArrow } from '../features/base/control-strip/functions';
import { emitSpaceChanged } from '../features/base/spaces/eventDispatcher';
import {hideAll} from 'tippy.js';
export default class  Conversations{
    constructor() {
        this.container = $("#convo-container");
        this.pinnedConversationContainer = $("#pinned-convo-container");
        //this.openConversationBtn=$("#convoPanelBtn");
        this.closeConversationBtn = $("#closeConvoBtn");
        this.toggleBtn = $("#panelToggle");
        this.panel = $("#myConvoPanel");
        this.createConversationBtn = $("#new-conversation-btn");
        this.conversations = {};
        this.myConversation = null;
        this.showExpandLimit = 4;
        this.room_id = ROOM_NAME;
        this.unFocusOnLeft = false;
        this.conversationBanner = $("#my-conversation-banner");
        this.showConversationBanner = $('#show-info-banner');
        this.showConversationBannerBtn = $('#show-info-banner-btn');
        this.bannerShown = false;
        this.hideBannerTimeout = 0;
        this.revealed = false;
        this.revealTimeout = 0;
        this.openPanelTimeout = 0;
        this.mouseOverPanel = false;
        this.togglePositionLimit = {
            top: 50,
            bottom: 80,
        };
        this.toggleBtnPosition = window.innerHeight - 235;
        this.toggleBtnDragging = false;
        this.invitesTimeout = {};

        this.sanitizeOptions = {
            allowedTags: [],
            allowedAttributes: {
                span: [],
                img: [],
            },
            allowedSchemesByTag: {
                img: [],
            },
        };
        //pinned conversations
        this.pinIcon = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14" x="0" y="0" viewBox="0 0 682.667 682.667" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><defs><clipPath id="a" clipPathUnits="userSpaceOnUse"><path d="M0 512h512V0H0Z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></clipPath></defs><g clip-path="url(#a)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)"><path d="m0 0 160.873 160.873" style="stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(20 20)" fill="none" stroke="#ffffff" stroke-width="40" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="m0 0-128.272-128.273c14.254-53.378.443-112.693-41.434-154.57L-395.979-56.569c41.875 41.877 101.19 55.688 154.569 41.433l128.273 128.273" style="stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(463.716 350.579)" fill="none" stroke="#ffffff" stroke-width="40" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="m0 0 169.706-169.706" style="stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(322.294 492)" fill="none" stroke="#ffffff" stroke-width="40" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path></g></g></svg>`;
        this.unpinIcon = `<svg version="1.1" width=20 height=20 id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
    <style type="text/css">
        .st0{fill:none;}
        .st1{fill:none;stroke:#000000;stroke-linejoin:round;stroke-miterlimit:10;}
        .st2{stroke:#000000;stroke-width:0.5;stroke-linejoin:round;stroke-miterlimit:10;}
        .st3{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
        .st4{fill:none;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}
    </style>
    <rect class="st0" width="24" height="24"/>
    <g>
        <g>
            <path class="st1" d="M11.9,0.5c0,0-6.2-0.1-6.2,2.1c0,1.3,2.9,2.5,2.9,2.5V11c0,0-3.6,0.3-3.6,1.9c0,1.2,1.8,2.4,6.8,2.4
                s6.8-1.1,6.8-2.4c0-1.5-3.6-1.9-3.6-1.9V5.1c0,0,2.9-1.2,2.9-2.5C18.1,0.4,11.9,0.5,11.9,0.5z"/>
        </g>
        <line class="st4" x1="2.5" y1="2.6" x2="21.5" y2="21.4"/>
        <g>
            <g>
                <polygon points="12.5,22.5 12,24 11.5,22.5          "/>
            </g>
            <line class="st3" x1="12" y1="15.2" x2="12" y2="22.4"/>
        </g>
    </g>
    </svg>
    `;
        this.loadingCircle = `<svg class="spinnerLoader"><circle class="pathLoader" cx="50" cy="50" r="30" fill="none" stroke-width="6" stroke-miterlimit="5" /></svg>`;
        this.defaultPrivateSpaceImage=`data:image/jpeg;base64,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`;
        this.host = HOST;
        this.guest_id = GUEST_ID;
        this.isJoining = false;
        this.private = undefined;
        this.myUserId = null;
        this.retryLoadSpaces=0;
        this.masterVolumeOverwrite=false;
        this.joinSpaceSource="";
        this.spacesLoading=true;
        this.countDownInterval=0;

        this.onJoinedKino=undefined;
        this.spacesFinishedLoading=false;
        this.arrowClicked=false
    }

    init() {
        let c = this;
        console.log("called conversation init");
        c.myUserId = room.myUserId();
        if(this.onJoinedKino){
            this.onJoinedKino();
        }
        // c.listConversations.call(c, c.room_id);
        //attach conversation joined event
        socket.events.SpaceJoined=(message)=>{
            try {
                if(c.conversations[message.id]){
                    c.conversations[message.id].participantJoined(message.pid);
                }
            } catch (error) {

            }
        };
        socket.events.SpaceLeft=(message)=>{
            try {
                if(c.conversations[message.id]){
                    if(c.myConversation==message.id && message.pid == room.myUserId() && !c.leaving){
                        if(permissions.leaveFallbackAssigned()
                        && permissions.initialSpace()
                        && c.spaceExists(permissions.initialSpace())
                        && permissions.initialSpace() != c.myConversation
                        ){
                            c.joinSpace(permissions.initialSpace())
                        }else{
                            c.leaveSpace();
                        }
                    }else{
                        c.conversations[message.id].participantLeft(message.pid);
                    }
                }
            } catch (error) {

            }
        };
        socket.events.ConversationJoined = function (request) {

        };
        // attach conversationleft event
        socket.events.ConversationLeft = function (request) {

        };

        socket.events.ConversationUnpin = function (request) {
            let data = request.data;
            console.log("Unpin conversation:", data.conversation_id);
            c.conversationUnPinned.call(c, data.conversation_id);
        };
        socket.events.ConversationPin = function (request) {
            let data = request.data;
            //console.log("Unpin conversation:",data.conversation_id);
            c.conversationPinned.call(c, data.conversation_id);
        };
        socket.events.NewPinnedConversation = function (request) {
            let conversation = request.data;
            c.newConversation(conversation,true);
            // c.appendConversation(conversation);
        };
        if (c.canPin()) {
            c.container.addClass("moderator");
            c.pinnedConversationContainer.addClass("moderator");
        }

        socket.events.conversationNameChanged = function (request) {
            let data = request.data;
            c.nameChanged(data.conversation_id, data.name);
        };
        socket.events.conversationJoinInvite = function (request) {
            let data = request.data;
            if (data.conversation_id == "new") {
                c.showNotification(
                    Video.conversationIcon,
                    "JOIN_NEW_CONVERSATION_INVITE",
                    data
                );
            } else if (data.conversation_id > 0) {
                c.showNotification(
                    Video.conversationIcon,
                    "JOIN_CONVERSATION_INVITE",
                    data
                );
            }
        };
        socket.events.conversationJoinInviteResponse = function (request) {
            let data = request.data;
            c.showNotification(
                Video.conversationIcon,
                "JOIN_CONVERSATION_INVITE_RESPONSE",
                data
            );
        };
        socket.events.FocusConversation = function (request) {
            let data = request;
            c.showNotification(Video.conversationIcon, "JOIN_CONVERSATION", {
                conversation_id: data.conversation_id,
                participant: data.focusedOn,
                displayName: Video.videos[data.focusedOn].displayName,
            });
        };
        socket.events.inviteCanceled = function (request) {
            console.log(
                "Called invite canceled",
                Video.notifications.find(
                    `.${request.data.participant}-notification.JOIN_NEW_CONVERSATION_INVITE`
                ).length
            );
            clearTimeout(c.invitesTimeout[request.data.participant]);
            Video.notifications
                .find(
                    `.${request.data.participant}-notification.JOIN_NEW_CONVERSATION_INVITE`
                )
                .remove();
        };
        //add event to banner
        // c.conversationBanner.find("#leave-conversation").on('click', function () {
        //     if(lockFocus.isLocked() && !permissions.hasSpacesLock()) {
        //         c.isJoining=false;
        //         lockFocus.showLockFocusNotification();
        //         return;
        //     }
        //     // c.userSpaceStatusChanged('leaving');
        //     if(permissions.leaveFallbackAssigned()
        //         && permissions.initialSpace()
        //         && c.spaceExists(permissions.initialSpace())
        //         && permissions.initialSpace() != c.myConversation){
        //             c.joinSpace(permissions.initialSpace());
        //         }else{
        //             c.leaveSpace();
        //         }
        // });
        //begin code card ID: 529
        c.conversationBanner
            .find("#make-conversation-private")
            .on("click", c.makePrivateButtonHandler.bind(c));
        socket.events.PrivateConversation =
            c.privateConversationMessageHandler.bind(c);

        $(document).on(
            "mouseover",
            ".my-convo-content, .my-convo-participants, .convo-image, .participants-count, .my-convo-name, .my-convo-buttons, #leave-conversation",
            function (e) {
                c.stopHideBannerTimeout();
            }
        );

        $(document).on(
            "mousemove",
            "#remoteVideos, #remoteVideosContainer, #toolEventsArea",
            function (e) {
                // controlStripOnMouseMove(e)
                // if(c.myConversation){
                //     c.showBanner(true);
                //     if(c.conversationBanner.hasClass("hiddenImportant") && c.showConversationBanner.hasClass('hiddenAnimated') && !bottomAction.bottomActionsContainer.hasClass("shownAnimated")){
                //         if (!c.myConversation) {
                //             return;
                //         }
                //         c.showBannerInfo();
                //     }
                // }else if(Object.keys(bottomAction.actions).length){
                //     if(!bottomAction.bottomActionsContainer.hasClass('hiddenImportant')){
                //         bottomAction.showBottomAction();
                //     }
                // }
            }
        );
        $(document).on(
            "mouseover",
            "#tool-box, #audioDevicesList, #videoDevicesList, #options-side-menu, #stripOptionsConatiner",()=>{
                // preventControlFromClosing();
            })
            $(document).on(
                "mouseleave",
                "#tool-box, #audioDevicesList, #videoDevicesList, #options-side-menu, #stripOptionsConatiner",()=>{
                    // allowControlClosing();
                })
        $("#my-convo-hide-btn").on("click", function (e) {
            c.conversationBanner.addClass("hiddenImportant");
            c.showBannerInfo()
        });

        c.showConversationBannerBtn.on('click', function(e){
            c.hideBannerInfo();
            if(CONV_STORAGE.myConversation){
                c.conversationBanner.removeClass("hiddenImportant");
            }else if(Object.keys(bottomAction.actions).length){
                bottomAction.showBottomAction();
            }
        })

        $(".arrow-up-conatiner").on("click", (e) => {
            this.arrowClicked = !this.arrowClicked
            if(this.arrowClicked){
                hideControlStrip()
                $("#tool-box").addClass("hidden-control-strip")
            }else {
                controlStripOnMouseMove(e)
                $("#tool-box").removeClass("hidden-control-strip")
            }
        })

        $(document).on("click", function (e) {
            if(!kinoControls.mouseOver && kinoControls.container && kinoControls.container.hasClass("animate-menu-show")){
                kinoControls.hideControlsMenu();
            }
        });
        c.toggleBtn.on("click", function (e) {
            if(!permissions.hasChat()){return}
            e.stopPropagation();
            console.log(
                "toggle click action, is dragging",
                c.toggleBtnDragging
            );
            if(c.panel.hasClass("open")){
                c.closePanel();
            }else{
                c.openPanel();
            }
        });
        $("#conversations-tab-nav").on("click", function () {
            console.log(
                "Navigating to conversations tab, is active",
                $(this).hasClass("active")
            );
            if (!$(this).hasClass("active")) {
                c.startConversationPlayers();
            }
        });
        //end card 599
        //initialize toggle conversations button
        let btnSavedPos = localStorage.getItem("toggleConversatonsPosition");
        let wheight = window.innerHeight;
        if (btnSavedPos) {
            if (
                btnSavedPos > c.togglePositionLimit.top &&
                wheight - btnSavedPos + 40 > c.togglePositionLimit.bottom
            ) {
                c.toggleBtn.css("top", btnSavedPos + "px");
            }
        } else {
            c.toggleBtn.css("top", c.toggleBtnPosition + "px");
        }
        c.dragToggleBtn();
        c.createConversationBtn.on("click", function () {
            //c.createPinnedConversation()
            $("#add-conversation-modal").modal("show");
        });

        $("#add-conversation-modal").on("shown.bs.modal", function () {
            $("#new-conversation-name-input").focus();
        });

        $("#exit-modal-btn-pinned-convo").on("click", function () {
            c.hideErrorMessageConvo();
            $("#new-conversation-name-input").val("");
        });

        $("#new-conversation-name-input").focus(function () {
            c.hideErrorMessageConvo();
        });

        $("#submit-create-conversation").on("click", function () {
            c.submitNewConversation();
        });
        $("#new-conversation-name-input").on("paste", (e) => {
            let conv_name = sanitizeHtml(
                $("#new-conversation-name-input").html(),
                this.sanitizeOptions
            );
            if (
                (conv_name + event.clipboardData.getData("text/plain"))
                    .length >= 30
            ) {
                return false;
            }
        });
        $("#new-conversation-name-input").on("keyup", (e) => {
            let code = e.keyCode || e.which;
            if (code == 13) {
                c.submitNewConversation();
            }
            let conv_name = sanitizeHtml(
                $("#new-conversation-name-input").html(),
                this.sanitizeOptions
            );
            if (conv_name.length > 30) {
                if (
                    code != 8 &&
                    code != 9 &&
                    code != 37 &&
                    code != 39 &&
                    !(code == 88 && e.ctrlKey)
                ) {
                    e.preventDefault();
                    return false;
                }
            }
        });
        $("#conversationsScroller").scroll(
            Video.efss.inViewPortConversations.bind(Video.efss, true)
        );
    }

    dragToggleBtn() {
        let c = this;
        var pos1 = 0,
            pos2 = 0,
            pos3 = 0,
            pos4 = 0;
        var wHeight = window.innerHeight;
        if (c.toggleBtn) {
            c.toggleBtn[0].style.top = c.toggleBtn[0].offsetTop + "px";
            c.toggleBtn[0].style.bottom = "unset";
            /* if present, the header is where you move the DIV from:*/
            c.toggleBtn[0].onmousedown = dragMouseDown;
        }

        function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            c.toggleBtnDragging = false;
            console.log("mouse down event");
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
            //get window height
            wHeight = window.innerHeight;
        }

        function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();
            //c.toggleBtnDragging=true;
            c.toggleBtn.css("cursor", "n-resize");

            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;

            //fix conflict with click
            if (Math.abs(pos1) >= 2 || Math.abs(pos2) >= 2) {
                c.toggleBtnDragging = true;
            }
            // set the element's new position:
            let newPos = c.toggleBtn[0].offsetTop - pos2;
            if (newPos < c.togglePositionLimit.top) {
                newPos = c.togglePositionLimit.top;
            }

            if (wHeight - (newPos + 40) < c.togglePositionLimit.bottom) {
                newPos = wHeight - (c.togglePositionLimit.bottom + 40);
            }

            c.toggleBtn[0].style.top = newPos + "px";
            localStorage.setItem("toggleConversatonsPosition", newPos);
            //c.toggleBtn[0].style.left = (c.toggleBtn[0].offsetLeft - pos1) + "px";
        }

        function closeDragElement() {
            /* stop moving when mouse button is released:*/
            //c.toggleBtnDragging=true;
            c.toggleBtn.css("cursor", "pointer");
            document.onmouseup = null;
            document.onmousemove = null;
        }
    }

    isOnConversation(pid) {
        let conversation_id = false;
        let p=kinoParticipants.get(pid);
        if(p && p.getSpaceId()){
            return p.getSpaceId();
        }
        return conversation_id;
    }

    openPanel() {
        // console.error("PANEL OPEN");
        let c = this;
        if(chat.isRecordingOrLiveStream() || chat.mainChat.isChatPopupOpen()){
            chat.openChatInPopUp();
            return;
        }
        c.mouseOverPanel = true;
        c.panel.addClass("open").removeClass("closed");
    }

    closePanel() {
        let c = this;
        hideAll();
        c.mouseOverPanel = false;
        c.panel.removeClass("open").addClass("closed");
    }

    keepPanelOpen() {
        let c = this;
        clearTimeout(c.openPanelTimeout);
    }

    startPanelClose(seconds = 5) {
        let c = this;
        clearTimeout(c.openPanelTimeout);
        c.openPanelTimeout = setTimeout(function () {
            // c.closePanel();
        }, seconds * 1000);
    }

    updateBanner() {
        let c = this;
        if (c.myConversation > 0) {
            if (c.conversations[c.myConversation] !== undefined) {
                //go update banner
                let name =
                    c.conversations[c.myConversation].name.length > 0
                        ? c.conversations[c.myConversation].name
                        : "Focused Space";
                let pcount =
                    c.conversations[c.myConversation].participants.length;
                console.log(
                    "Updating conversation banner , participants:" + pcount
                );
                c.conversationBanner.find(".my-convo-name").html(name);
                c.conversationBanner.find(".participants-count").html(pcount);
            }
        }
    }

    showBanner(timeout = false) {
        let c = this;
        if (!c.myConversation) {
            return;
        }
        if (timeout) {
            c.startHideBannerTimeout(5);
        }
        if (c.bannerShown === true) {
            return
        };
        c.bannerShown = true;
        lockFocus.updateUnlockButtonPosition();
        bottomAction.spacesBannerStateChanged();
        c.conversationBanner.removeClass("hiddenAnimated").addClass("shownAnimated");
    }
    hideBanner() {
        let c = this;
        c.stopHideBannerTimeout();
        c.conversationBanner.removeClass("shownAnimated").addClass("hiddenAnimated");
        c.bannerShown = false;
        if(c.myConversation){
            return;
        }
        lockFocus.updateUnlockButtonPosition();
        bottomAction.spacesBannerStateChanged();
    };

    showBannerInfo(){
        let c = this;
        c.showConversationBanner.removeClass('hiddenAnimated').addClass('shownAnimated')
    }
    hideBannerInfo(){
        let c = this;
        c.showConversationBanner.removeClass('shownAnimated').addClass('hiddenAnimated')
    }
    stopHideBannerTimeout() {
        let c = this;
        clearTimeout(c.hideBannerTimeout);
    }
    startHideBannerTimeout(seconds = 5) {
        let c = this;
        clearTimeout(c.hideBannerTimeout);
        c.hideBannerTimeout = setTimeout(function () {
            c.hideBanner();
            c.hideBannerInfo();
        }, seconds * 1000);
    }

    revealParticipants() {
        let c = this;
        if (c.myConversation) {
            Video.videoSpace.addClass("my-conversation-view");
            $.each(
                c.conversations[c.myConversation].participants,
                function (i, p) {
                    if(!p){return}
                    if (Video.videos[p.participant] !== undefined) {
                        Video.videos[p.participant].viewContainer.addClass(
                            "revealed"
                        );
                    }
                }
            );
        }
        clearTimeout(c.revealTimeout);

        c.revealTimeout = setTimeout(function () {
            c.unRevealParticipants();
        }, 2000);
    }
    unRevealParticipants() {
        let c = this;
        Video.videoSpace.removeClass("my-conversation-view");
        if (c.myConversation) {
            $.each(
                c.conversations[c.myConversation].participants,
                function (i, p) {
                    if(!p){return}
                    if (Video.videos[p.participant] !== undefined) {
                        Video.videos[p.participant].viewContainer.removeClass(
                            "revealed"
                        );
                    }
                }
            );
        }
    }

    async recoverSpaces(kino_id = false){
        let c=this;
        if (!kino_id) {
            kino_id = c.room_id;
        }
        c.spacesLoading=true;
        console.log("Recovering Spaces");
        axios.post(convertPath(`/conversations/${kino_id}`),{}, await electronConfig())
            .then((res) => {
                let newSpaces = res.data;
                if(newSpaces.length==0 && Object.keys(c.conversations).length == 0){
                    console.log("No spaces to recover")
                    c.spacesLoading=false;
                    return;
                }
                if(newSpaces.length==0){
                    if(c.myConversation){
                        c.leaveSpace(()=>{
                            c.conversations = {};
                            c.container.html("");
                            c.pinnedConversationContainer.html("");
                            Video.enableLobbyView();
                        });
                    }else{
                        c.conversations = {};
                        c.container.html("");
                        c.pinnedConversationContainer.html("");
                        if(Object.keys(Video.focused).length==0){
                            Video.enableLobbyView();
                        }

                    }
                }
                //check for deleted spaces
                let newSpaceIds=newSpaces.map(s=>parseInt(s.id));
                Object.keys(c.conversations).forEach(id=>{
                    if(!newSpaceIds.includes(parseInt(id))){
                        console.log("found a space that was deleted",c.conversations[id]);
                        if(id==c.myConversation){
                            c.leaveSpace().then(()=>{
                                c.spaceDeleted(id);
                            });
                        }else{
                            c.spaceDeleted(id);
                        }
                    }
                });
                //check existing spaces
                newSpaces.forEach(newSpace=>{
                    if(c.conversations[newSpace.id]){
                        if(c.isSpaceChanged(c.conversations[newSpace.id],newSpace)){
                            console.log(`found a space that was changed`);
                            console.log("Was",c.conversations[newSpace.id]);
                            console.log("Now",newSpace);
                            let oldparticipants=c.conversations[newSpace.id].participants.filter(p=>p);
                            let newParticipants=newSpace.participants.map(p=>p.participant);
                            console.log("Comparing participants old:",oldparticipants);
                            console.log("Comparing participants new:",newParticipants);
                            //check for participants that left
                            oldparticipants.forEach(oldid=>{
                                if(!newParticipants.includes(oldid)){
                                    //this participant left this space
                                    console.log("Found a participant that left space when I was disconnected",oldid)
                                    Video.unFocusedMe(oldid);
                                    socket.events.SpaceLeft.call(c, {
                                            id: newSpace.id,
                                            pid: oldid,
                                            room_id: c.room_id,
                                    });
                                }
                            });

                            //check for new participants that joined
                            newParticipants.forEach(newid=>{
                                if(!oldparticipants.includes(newid)){
                                    console.log("Found a new participant that joined when I was disconnected",newid)
                                    if(newid==c.myUserId && (!c.myConversation || c.myConversation != newSpace.id)){

                                        socket.spaceLeftMessage(newSpace.id);
                                    }else{
                                        socket.events.SpaceJoined.call(c,{
                                                id: newSpace.id,
                                                pid: newid
                                        });

                                    }

                                }
                            });

                            if(!c.conversations[newSpace.id].is_private && newSpace.is_private){
                                //space changed to private
                                console.log("Found a space that was changed to private when was disconnected",c.conversations[newSpace.id])
                                c.privateConversationMessageHandler({
                                    eventName:"PrivateConversation",
                                    conversation_id:newSpace.id,
                                    action:"PrivacyChanged",
                                    data:{
                                        is_private:true,
                                        from_id:newSpace.made_private_by
                                    }});
                                //update thumbanils
                                // if(newSpace.id!=c.myConversation){
                                    console.log("update thumbnails for participants",newSpace.participants);
                                    newSpace.participants.forEach(p=>{
                                        if(!p){return}
                                        if(p.participant != room.myUserId()){
                                            c.getThumbnail(newSpace.id,p.participant);
                                        }
                                    });
                                // }
                            }else if(c.conversations[newSpace.id].is_private && !newSpace.is_private){
                                //space chnaged to not private
                                console.log("Found a space that was chnaged to not private when was disconnected",c.conversations[newSpace.id])
                                c.privateConversationMessageHandler({
                                    eventName:"PrivateConversation",
                                    conversation_id:newSpace.id,
                                    action:"PrivacyChanged",
                                    data:{
                                        is_private:false,
                                        from_id:newSpace.made_private_by
                                    }});
                            }
                            if(newSpace.name){
                                //change space name
                                c.nameChanged(newSpace.id,newSpace.name);
                            }
                        }
                        if(c.myConversation){
                            c.updateBanner();
                        }
                    }
                });
                //check for new created spaces
                newSpaceIds.forEach(nid=>{
                    if(!c.conversations[nid]){
                        let newSpace=newSpaces.find(s=>s.id==nid);
                        if(newSpace){
                            console.log(`Found new space created when disconnected`,newSpace);
                            c.newConversation(newSpace);
                            // c.appendConversation(newSpace);
                        }
                    }
                });

                c.spacesLoading=false;
            }).catch(err=>{
                console.error(`Recover spaces error`,err)
                c.spacesLoading=false;
            });
    };

    spaceDeleted(space_id){
        let c=this;
        if(c.conversations[space_id]){
            if(c.conversations[space_id].participants.length==0){
                this.destroySpace(space_id);
                return;
            }
            c.conversations[space_id].participants.forEach(p=>{
                // c.removeParticipant(space_id,p);
                if(p=room.myUserId() && c.myConversation == space_id){
                    c.leaveSpace();
                }else{
                    c.conversations[space_id].participantLeft(p);
                }
            });
            this.destroySpace(space_id);
        }
    }

    isSpaceChanged(existingSpace,newSpace){
        console.log(`comparing participants array type old space: ${existingSpace.participants.length} new space : ${typeof newSpace.participants}`);
        try {
            existingSpace.participants=existingSpace.participants.filter(p=>p);
            this.conversations[existingSpace.id].participants=existingSpace.participants;
            newSpace.participants=Object.values(newSpace.participants);
        } catch (error) {

        }
        if(existingSpace.name != newSpace.name && newSpace.name){
            return true;
        }
        if(existingSpace.is_private != newSpace.is_private){
            return true;
        }
        if(existingSpace.participants.length != newSpace.participants.length){
            return true;
        }

        let existingParticipants=existingSpace.participants.sort().join();
        let newParticipants=newSpace.participants.map(p=>p.participant).sort().join();
        if(existingParticipants != newParticipants){
            return true;
        }

        return false;

    };

    async getSpacesApi(kino_id = false){
        if (!kino_id) {
            kino_id = this.room_id;
        }
        const Token = await electronConfig()
        return new Promise((resolve,reject)=>{
            axios.get(convertPath(`/spaces/list`) + `?kino_id=${kino_id}&guest_id=${GUEST_ID}`,Token)
            .then((res) => {
                resolve(res.data)
            }).catch(err=>{
                reject(err);
            })
        });
    }

    async prepareSpaces(kino_id = false){
        try {
            console.log("[SPACES] Preparing spaces KinoID:",kino_id)
            this.spacesLoading=true;
            let loadingSpinner=$("<div/>",{
                html:`<svg class="circular white">
                <circle class="path" cx="10" cy="10" r="8" fill="none" stroke-width="2" stroke-miterlimit="10" />
              </svg> Loading spaces...`,
              class:"loading-spaces"
            });
            this.container.html("");
            this.pinnedConversationContainer.html(loadingSpinner);

            const spaces = await this.getSpacesApi(kino_id);
            if(!isJoined){
                console.log("[SPACES] Conference not joined yet, adding event onJoinedKino")
                this.onJoinedKino=()=>{
                    this.applySpaces(spaces);
                    setTimeout(() => {
                        lobby.removeJoiningTheKinoOverlay();
                    }, 500);
                }
            }else{
                console.log("[SPACES] Conference is joined, applySpaces")
                this.applySpaces(spaces);
                setTimeout(() => {
                    lobby.removeJoiningTheKinoOverlay();
                }, 500);
            }
            this.spacesLoading=false
            this.pinnedConversationContainer.html("");
        } catch (error) {
            this.spacesLoading=false
            console.log("[SPACES ERROR] loading spaces error",error)
        }
    }

    applySpaces(conversations){
        console.warn("[SPACES] Applying Spaces",conversations)
        this.conversations = {};
        this.myConversation = null
        if(!onStage.isActive()){
            this.unFocusNonConvo();
        }
        spacesView.populateLobbyParticipants();
        let participants = 0;
        let lastSpace=permissions.initialSpace() ? {id:permissions.initialSpace(),is_private:false} : this.getLastSpaceId();
        let assignedSpace=permissions.initialSpace();
        let previousSpaceFound=false;
        if(Object.keys(Video.videos).length >= 1){
            this.sendRemoveJoiningLayer();
        }

        if (conversations.length == 0) {
            if (PARTICIPANTS_IN_CONVO.length > 0) {
                PARTICIPANTS_IN_CONVO = [];
                Video.enableLobbyView();
            }
            if(lastSpace && room.getLocalAudioTrack() && !room.getLocalAudioTrack().isMuted()){
                muteAll.checkMuteAllPolicy();
            }
            muteAll.onUserSpaceChanged();
            return;
        }

        console.log("My default space is ",lastSpace);
        // conversations.sort(
        //     (firstConv, secondConv) =>
        //         firstConv.participants.length -
        //         secondConv.participants.length
        // );
        conversations.forEach((conversation) =>{
            let participantsToArray =
            typeof conversation.participants.forEach == "function"
            ? new Array(...conversation.participants)
            : Object.values(conversation.participants);
            conversation.participants=participantsToArray;
            participants += conversation.participants.length;
            if(conversation.is_private){
                conversation.participants.forEach(p=>{
                    if(p.thumbnail && Video.videos[p.participant]){
                        Video.videos[p.participant].thumbnail=p.thumbnail;
                    }
                });
            }
            this.newConversation(conversation);
            if(lastSpace?.id==conversation.id && this.conversations[lastSpace?.id]){
                previousSpaceFound=true;
            }else if(!PARTICIPANTS_IN_CONVO.length > 0){
                this.storeLastSpaceId('');
            }
        });

        if (participants == 0) {
            Video.enableLobbyView();
        }
        PARTICIPANTS_IN_CONVO = [];
        this.spacesFinishedLoading=true;
        Video.verifyInitialVolume();
        let volume = volumeManager.masterMuted ? 0 : 0.05;
        volumeManager.changeMasterVolume(volume, volumeManager.muteVolumeOverwrite ? 0 : 0.05);
        let joinSpaceVolume=volumeManager.muteVolumeOverwrite ?0:false;

        if(previousSpaceFound && this.conversations[lastSpace?.id] && !onStage.isActive()){
            const timeout=assignedSpace == lastSpace?.id ? 0 : 1500;
            const showJoiningSpace = lastSpace && (!permissions.shouldRequestToJoinPrivateSpace() || lastSpace?.id==permissions.initialSpace() || lastSpace?.is_private);
            // setTimeout(() => {
              console.log("[SPACES] Joining previous space",lastSpace);
              showJoiningSpace && this.userSpaceStatusChanged("joining_last_space");
              setTimeout(() => {
                  if(this.conversations[lastSpace?.id].is_private){
                        console.log("Can user join private space",(!permissions.shouldRequestToJoinPrivateSpace() || lastSpace?.id==permissions.initialSpace()))
                        if(!permissions.shouldRequestToJoinPrivateSpace() || lastSpace?.id==permissions.initialSpace() || lastSpace?.is_private){
                            this.joinPrivateSpaceAsModerator(lastSpace?.id,joinSpaceVolume);
                        }else{
                            if(room.getLocalAudioTrack() && !room.getLocalAudioTrack().isMuted()){
                                muteAll.checkMuteAllPolicy();
                                muteAll.onUserSpaceChanged();
                            }
                        }
                  }else if(!this.conversations[lastSpace?.id].is_private){
                        this.joinSpace(lastSpace?.id,joinSpaceVolume).then(()=>console.log("Joined previous space")).catch(err=>{
                            console.log("Failed to join previous space",err);
                            if(room.getLocalAudioTrack() && !room.getLocalAudioTrack().isMuted()){
                                muteAll.checkMuteAllPolicy();
                            }
                            muteAll.onUserSpaceChanged();
                        });
                  }
              }, timeout);

            // }, 2000);
            this.storeLastSpaceId('');
        }else if(lastSpace){
            if(room.getLocalAudioTrack() && !room.getLocalAudioTrack().isMuted()){
                muteAll.checkMuteAllPolicy();
                muteAll.onUserSpaceChanged();
            }
        }
    }

    async listConversations(kino_id = false,retrytimes=3) {
        let c = this;
        if (!kino_id) {
            kino_id = c.room_id;
        }
        console.warn("Getting spacess")
        clearTimeout(this.retryLoadSpaces);
        c.spacesLoading=true;
        c.conversations = {};
        Video.myConversation = {};
        c.myConversation = null;
        let loadingSpinner=$("<div/>",{
            html:`<svg class="circular white">
            <circle class="path" cx="10" cy="10" r="8" fill="none" stroke-width="2" stroke-miterlimit="10" />
          </svg> Loading spaces...`,
          class:"loading-spaces"
        });
        c.container.html("");
        c.pinnedConversationContainer.html(loadingSpinner);
        if(!onStage.isActive()){
            c.unFocusNonConvo();
        }
        spacesView.populateLobbyParticipants();
        axios.post(convertPath(`/conversations/${kino_id}`),{}, await electronConfig())
            .then((res) => {
                c.pinnedConversationContainer.html("");
                let conversations = res.data;
                let participants = 0;
                let lastSpace=permissions.initialSpace() ? permissions.initialSpace() : c.getLastSpaceId();
                let previousSpaceFound=false;
                if(Object.keys(Video.videos).length >= 1){
                    c.sendRemoveJoiningLayer();
                }
                if (conversations.length == 0) {
                    if (PARTICIPANTS_IN_CONVO.length > 0) {
                        PARTICIPANTS_IN_CONVO = [];
                        Video.enableLobbyView();
                    }
                    c.spacesLoading=false;
                    if(lastSpace && room.getLocalAudioTrack() && !room.getLocalAudioTrack().isMuted()){
                        muteAll.checkMuteAllPolicy();
                    }
                    muteAll.onUserSpaceChanged();
                    return;
                }
                console.log("iterating conversations my last space is ",lastSpace);
                // conversations.sort(
                //     (firstConv, secondConv) =>
                //         firstConv.participants.length -
                //         secondConv.participants.length
                // );
                conversations.forEach((conversation) =>{
                    let participantsToArray =
                    typeof conversation.participants.forEach == "function"
                    ? new Array(...conversation.participants)
                    : Object.values(conversation.participants);
                    conversation.participants=participantsToArray;
                    participants += conversation.participants.length;
                    if(conversation.is_private){
                        conversation.participants.forEach(p=>{
                            if(p.thumbnail && Video.videos[p.participant]){
                                Video.videos[p.participant].thumbnail=p.thumbnail;
                            }
                        });
                    }
                    c.newConversation(conversation);
                    // c.appendConversation(conversation);
                    // if(c.conversations[lastSpace] && c.conversations[lastSpace].is_private){
                    //     previousSpaceFound = false;
                    //     c.storeLastSpaceId('');
                    // }
                    if(lastSpace==conversation.id && c.conversations[lastSpace]){
                        previousSpaceFound=true;
                    }else if(!PARTICIPANTS_IN_CONVO.length > 0){
                        c.storeLastSpaceId('');
                    }
                    //begin card 529
                    //check if is a private conversation
                    //end card 529
                });


                if (participants == 0) {
                    Video.enableLobbyView();
                }
                c.spacesLoading=false;
                PARTICIPANTS_IN_CONVO = [];
                c.spacesFinishedLoading=true;
                Video.verifyInitialVolume();
                let volume = volumeManager.masterMuted ? 0 : volumeManager.masterVolume;
                volumeManager.changeMasterVolume(volume, volumeManager.muteVolumeOverwrite ? 0 : 0.05);
                let joinSpaceVolume=volumeManager.muteVolumeOverwrite ?0:false;
                if(previousSpaceFound && c.conversations[lastSpace]){
                    setTimeout(() => {
                      console.log("Joining previous space",lastSpace);
                      c.userSpaceStatusChanged("joining_last_space");
                      setTimeout(() => {
                          if(c.conversations[lastSpace].is_private){
                                console.log("Can user join private space",(!permissions.shouldRequestToJoinPrivateSpace() || lastSpace==permissions.initialSpace()))
                                if(!permissions.shouldRequestToJoinPrivateSpace() || lastSpace==permissions.initialSpace()){
                                    c.joinPrivateSpaceAsModerator(lastSpace,joinSpaceVolume);
                                }else{
                                    if(room.getLocalAudioTrack() && !room.getLocalAudioTrack().isMuted()){
                                        muteAll.checkMuteAllPolicy();
                                        muteAll.onUserSpaceChanged();
                                    }
                                }
                          }else if(!c.conversations[lastSpace].is_private){
                                c.joinSpace(lastSpace,joinSpaceVolume).then(()=>console.log("Joined previous space")).catch(err=>{
                                    console.log("Failed to join previous space",err);
                                    if(room.getLocalAudioTrack() && !room.getLocalAudioTrack().isMuted()){
                                        muteAll.checkMuteAllPolicy();
                                    }
                                    muteAll.onUserSpaceChanged();
                                });
                          }
                      }, 1000);

                    }, 2000);
                    c.storeLastSpaceId('');
                }else if(lastSpace){
                    if(room.getLocalAudioTrack() && !room.getLocalAudioTrack().isMuted()){
                        muteAll.checkMuteAllPolicy();
                        muteAll.onUserSpaceChanged();
                    }
                }
            })
            .catch((err) => {console.error("ERROR GETTING SPACES", err)
                c.spacesLoading=false;
                if(retrytimes>0){
                    retrytimes--;
                    this.retryLoadSpaces=setTimeout(() => {
                        this.listConversations(kino_id,retrytimes);
                    }, 1000);
                }
            });
    }

    nameChanged(cid, name) {
        let c = this;
        if (c.conversations[cid] !== undefined) {
            c.conversations[cid].name = name;
            c.conversations[cid].spaceName.html(name);
            c.conversations[cid].spaceNameHeading.html(name)
            if(c.conversations[cid].isPinned()){
                spacesView.orderPinnedSpaces();
            }else{
                spacesView.orderNonPinnedSpaces();
            }
        }
        c.updateBanner();
    }


    //participant parameter is an object {conversation_id,participant,displayName}
    addParticipant(conversation_id, participant) {
        console.log("Function: addParticipant "+participant);
        let c = this;
        // console.log(
        //     `Adding participant to conversation ${conversation_id}:`,
        //     participant
        // );
        if (c.conversations[conversation_id] !== undefined) {
            c.conversations[conversation_id].participants.push(participant);
            c.appendParticipant(
                participant,
                c.conversations[conversation_id].htmlElement.find(
                    ".conversation-tiles"
                )
            );
        } else {
            let newConvo = c.newEmptyConversation(conversation_id, [
                participant,
            ]);
            c.appendConversation(newConvo);
        }
    }

    removeParticipant(conversation_id, participant_id) {
        console.log(
            `Function: removeParticipant(conversation_id:${conversation_id},participant_id:${participant_id})`
        );
        let c = this;
        if (c.conversations[conversation_id] !== undefined) {
            if (room.myUserId() == participant_id) {
                if (c.myConversation && c.myConversation == conversation_id) {
                    console.log(
                        `I just left a converation... ${c.myConversation}`
                    );
                    c.myConversation = null;
                    c.conversations[conversation_id].htmlElement.removeClass(
                        "my-conversation"
                    );
                    c.hideBanner();
                    Video.speaker.removePreviousSpeaker();
                    Video.enableLobbyView();
                } else {
                    console.log("Already left that conversation");
                    return;
                }
            } else {
                if (Video.videos[participant_id]) {
                    Video.videos[participant_id].notificationBar.html("");
                }
            }
            console.log(
                "remove from conversation participant" + participant_id,
                c.conversations[conversation_id].participants
            );
            $.each(
                c.conversations[conversation_id].participants,
                function (i, participant) {
                    if (typeof participant === "undefined") {
                        return;
                    }
                    console.log(
                        "conversation participant: index " + i,
                        participant
                    );
                    if (participant_id == participant.participant) {
                        //found participant to remove
                        console.log("removing participant from conversation");
                        delete c.conversations[conversation_id].participants[i];
                        if (Video.focused[participant_id]) {
                            //remove focus if not removed
                            Video.unFocusVideo(participant_id);
                        }
                        console.log(
                            "participants on conversation after remove of " +
                                participant
                        );
                        console.log(
                            c.conversations[conversation_id].participants
                        );
                        stopMediaPlayers(
                            c.conversations[conversation_id].htmlElement.find(
                                `.pid_${participant_id}`
                            )
                        ); //card 556
                        c.conversations[conversation_id].htmlElement
                            .find(`.pid_${participant_id}`)
                            .remove();
                        if (
                            Video.isLobbyView &&
                            !Video.isFocused &&
                            conversation_id != c.myConversation &&
                            (participant_id != room.myUserId() || room == null)
                        ) {
                            Video.addParticipantToLobby(participant_id);
                        }
                    }
                }
            );
            //clean deleted indexes
            if (
                typeof c.conversations[conversation_id].participants ==
                    "object" ||
                typeof c.conversations[conversation_id].participants == "array"
            ) {
                c.conversations[conversation_id].participants = c.conversations[
                    conversation_id
                ].participants.filter(function (a) {
                    return a;
                });
            } else {
                console.error(
                    "conversation partisipants is not a array type:" +
                        typeof c.conversations[conversation_id].participants,
                    c.conversations[conversation_id].participants
                );
            }

            console.log("conversation participants after clean");
            console.log(c.conversations[conversation_id].participants);

            if (c.conversations[conversation_id].participants.length <= 1) {
                //empty conversation : remove
                console.log("conversation is empty removing container");
                c.removeConversation.call(c, conversation_id);
            }
            if (c.conversations[conversation_id] !== undefined) {
                if (
                    c.conversations[conversation_id].participants.length <=
                    c.showExpandLimit
                ) {
                    c.conversations[conversation_id].expandBtn.removeClass(
                        "expand"
                    );
                }
            }

            if (conversation_id == c.myConversation) {
                c.updateBanner();
            }
        } else {
            if (room.myUserId() == participant_id && !c.myConversation) {
                console.log("I just left a converation...");
                //Video.speaker.removePreviousSpeaker();
                Video.enableLobbyView();
            }
        }
        c.changeConversationOrder(conversation_id);
    }

    removeConversation(conversation_id) {
        console.log(
            `Function: removeConversation(conversation_id:${conversation_id})`
        );
        let c = this;
        try {
            if (c.conversations[conversation_id] !== undefined) {
                if (c.conversations[conversation_id].conv_type == "pinned") {
                    return;
                }
            }
            if (conversation_id == c.myConversation) {
                c.leaveSpace();
            } else {
                if (c.conversations[conversation_id].participants.length == 1) {
                    socket.events.ConversationLeft.call(c, {
                        data: {
                            conversation: conversation_id,
                            participants: [
                                c.conversations[conversation_id].participants[0]
                                    .participant,
                            ],
                            room_id: c.room_id,
                        },
                    });
                } else {
                    c.conversations[conversation_id].container.remove();
                    delete c.conversations[conversation_id];
                }
            }
        } catch (e) {
            console.log("conversation remove error", e);
        }
        c.hideBanner();
    }

    destroySpace(id){
        if (this.conversations[id] !== undefined) {
            this.conversations[id].removeSpace();
            delete this.conversations[id];
        }
    };
    join (id,withToken=false,ignoreLockFocus=false,overwriteMasterVolume=false) {//card 539
        console.log(`JOIN ${id} Master volume:${overwriteMasterVolume}, ignoreLock:${ignoreLockFocus}`)
        //console.log(`Function: join(conversation_id:${id})`);
        let c = this;
        c.hideBannerInfo();
        // c.conversationBanner.removeClass("hiddenImportant");
        //lock focus
        if(lockFocus.isLocked() && !ignoreLockFocus && !c.isModerator()){//card 539
            c.isJoining=false;
            c.setJoining(false);//card 758
            lockFocus.showLockFocusNotification();
            return;
        //begin code card ID: 529
        }else if(c.conversations[id]!==undefined && c.conversations[id].is_private && !withToken){
            c.isJoining=false;
            c.setJoining(false);//card 758
            c.showNotification('<i class="fas fa-lock fa-lg" style="color:#fff"></i>', "CONVERSATION_IS_PRIVATE",{conversation_id:id});
            return;
        }
        //end code card ID: 529

        if (c.conversations[id] === undefined) {
            c.isJoining=false;
            c.setJoining(false);//card 758
            return;
        }
        //begin card 755
        if(c.myConversation==id){
            c.showBanner();
            c.isJoining=false;
            c.setJoining(false);//card 758
            return;
        }
        //end card 755
        let participants = [];
        if (
            typeof c.conversations[id].participants == "object" ||
            typeof c.conversations[id].participants == "array"
        ) {
            c.conversations[id].participants.filter(function (e) {
                return participants.push(e.participant);
            });
        } else {
            console.log(
                `not a array Type is ${typeof c.conversations[id]
                    .participants} `,
                c.conversations[id].participants
            );
        }
        //begin card 529
        participants.map((pid) => {
            if (Video.videos[pid] === undefined) {
                try {
                    console.warn("Clean participant", pid);
                    c.removeParticipant(id, pid);
                } catch (error) {
                    console.error("Error:", error);
                }
            }
        });
        participants = participants.filter(
            (pid) => Video.videos[pid] !== undefined
        );
        if (c.conversations[id] === undefined) {
            c.isJoining = false;
            c.setJoining(false); //card 758
            return;
        }
        //end card 529
        /*
        if (c.myConversation == id) {
            c.showBanner();
            c.isJoining=false;
            c.setJoining(false);//card 758
            return;
        }*/

        if (participants.length <= 1  && c.conversations[id].conv_type != "pinned") {
            c.isJoining=false;
            c.setJoining(false);//card 758
            return;
        }
        if(Video.presenter.isPresenterView){
            Video.presenter.removePresenter(true);
        }
        Video.clearDeadFocused();
        //enter in focused view if no participants
        if (participants.length == 0) {
            Video.focusedView();
            c.aloneConversationVolume(overwriteMasterVolume);
        }
        //c.unFocusAll();
        // if(Video.stealFocus.focusOnMe){
        //     Video.stealFocus.removeReleaseFocusButton();
        //     Video.stealFocus.setFocusedOnMe(false);
        // }
        c.myConversation = id;
        let wasVolumeOverwriten=c.masterVolumeOverwrite;
        c.masterVolumeOverwrite=overwriteMasterVolume;
        Video.myConversation.id = id;
        Video.myConversation.participants = participants;
        Video.notifications.find(`.${room.myUserId()}-notification`).remove();
        Video.notifications.find(".INVITE_WAITING_RESPONSE").remove();
        //socket.sendFocusSignal(participant, 'autoFocusMe');
        //c.unFocusNonConvo();
        //begin card 529
        socket.sendFocusConversation(participants, id,withToken);
        //end card 529
        console.log('focusing participants', participants);
        //console.log("Video class", Video);
        //$.each(participants, function (i, val) {
        for (const val of participants) {
            Video.onConversation[val] = id;
            if (Video.videos[val]) {
                Video.videos[val].focusButton.addClass("active");
                // Video.videos[val].focusButton.attr("title", "Unfocus");
                // Video.videos[val].focusButton.attr(
                //     "data-original-title",
                //     "Unfocus"
                // );
                //begin card 529
                c.updateThumbnailImage(val);
                c.updateConversationThumbnail(val);
                Video.focusVideo(val, "conversation", false, withToken);
                //end card 529
                Video.videos[val].notificationBar.html("");
            }
        }
        //});
        c.showBanner();

        //overwrite master volume
        if(overwriteMasterVolume!==false){
            if(overwriteMasterVolume===0){
                Video.lastMasterVolume=0.05;
            }
            Video.changeMasterVolume(overwriteMasterVolume);
        }else if(overwriteMasterVolume===false && wasVolumeOverwriten===0 && Video.masterMuted){
            Video.changeMasterVolume(0.05);
        }



        //presenter view if someone is sharing screen
        if (c.conversations[id].playingPresenter != undefined) {
            Video.enableShareScreenView(c.conversations[id].playingPresenter);
        }
        //begin card 529
        try {
            if (c.conversations[id].is_private) {
                c.private = new PrivateConversation(
                    c.myConversation,
                    c.conversations[id].made_private_by
                );
                c.private.sendPrivateStreamIds();
                c.updateMakePrivateButton(true);
                c.sendPrivacyThumbnail(id);
            } else {
                if (c.private) {
                    c.private.stopSendingStreamsPrivate();

                    c.private = undefined;
                    c.sendPrivacyThumbnail(id, true);
                }
                c.updateMakePrivateButton(false);
            }
        } catch (error) {
            console.log("error clearig private conversation", error);
        }
        if(c.joinSpaceSource=="split-spaces" && !Video.isLocalMaximized){
            Video.localVideoMaximize();
        }

        //end card 529
        c.isJoining=false;
        c.setJoining(false);//card 758
        // Video.setQuality();
        updateVideoQuality();
        this.changeConversationOrder(id)        // card 640
        muteParticipants.renderMuteButtons();
        // Video.stealFocus.renderPullFocusButtons();
        Video.stateChangedWhileMuted=true;
        console.log(`JOINED ${id} *************************************************************************************`);
        // console.log('MY ID: ',room.myUserId())
        c.userJoiningSpace(id, room.myUserId());
    };
    async leave (afterleave = false) {//card 760
        console.log(`LEAVE ***`);
        let c = this;
        c.storeLastSpaceId('');
        c.hideBannerInfo();
        // c.conversationBanner.removeClass("hiddenAnimated");
        if (Video.presenter.isPresenterView) {
            Video.presenter.removePresenter(true);
        }
        Video.notifications.find(".INVITE_WAITING_RESPONSE").remove();
        Video.notifications.find(".JOIN_CONVERSATION_INVITE_RESPONSE").remove();

        Video.notifications.find(".FOCUS_OR_INVITE").remove();
        Video.notifications.find(".JUMP_TO_OTHER_CONVO").remove();
        //begin card 529
        let leftConvoId = c.myConversation;
        //end card 529
        Video.clearDeadFocused();
        if(c.myConversation){
            c.leaveConversationVolume();
            c.removeParticipant(c.myConversation,room.myUserId());
        }
        c.myConversation = null;
        c.storeLastSpaceId('');
        //c.masterVolumeOverwrite=false;
        c.joinSpaceSource="";
        Video.myConversation.id = null;
        Video.myConversation.participants = [];
        //begin card 529
        try {
            console.log(
                "Checking if is a private space",
                c.conversations[leftConvoId]
            );
            if (
                c.conversations[leftConvoId] &&
                c.conversations[leftConvoId].is_private
            ) {
                let inConversationParticipants = [];
                c.conversations[leftConvoId].participants.filter(function (e) {
                    return inConversationParticipants.push(e.participant);
                });
                console.error(
                    "Participants in private space",
                    inConversationParticipants
                );
                inConversationParticipants.forEach((pid) => {
                    if (Video.videos[pid]) {
                        console.log(
                            "Participant in private space",
                            Video.videos[pid]
                        );
                        c.updateThumbnailImage(pid);
                        c.updateConversationThumbnail(pid);
                    }
                });
                console.log("Private conversation object",c.private);
                if(c.private && c.private.from_id == c.myUserId){
                    //begin card 760
                    try {
                        await c.destroyPrivateConversation();
                    } catch (error) {}
                    //end card 760
                }else if(c.private){
                    c.private.stopSendingStreamsPrivate();
                    c.sendPrivacyThumbnail(leftConvoId,true);
                    c.private=undefined;
                    c.updateMakePrivateButton(false);
                }

            }else if(!c.conversations[leftConvoId]){
                if(c.private && c.private.from_id == c.myUserId){
                     //begin card 760
                     try {
                        await c.destroyPrivateConversation();
                    } catch (error) {}
                    //end card 760
                }else if(c.private){
                    c.private.stopSendingStreamsPrivate();
                    c.sendPrivacyThumbnail(leftConvoId,true);
                    c.private=undefined;
                    c.updateMakePrivateButton(false);
                }
            }
        } catch (error) {
            console.error("Leaving private space update thumbnails", error);
        }
        if (leftConvoId) {
            socket.sendBroadcastMessage({
                eventName: "ConversationLeave",
                data: {
                    conversation_id: leftConvoId,
                    participant: c.myUserId,
                    room_id: c.room_id,
                },
                room_id: c.room_id,
            });
        }

        //end card 529
        c.hideBanner();
        c.unFocusNonConvo([],leftConvoId);
        Video.speaker.removePreviousSpeaker();
        if(Video.isFocused && !Video.isLobbyView){
          Video.enableTileView();
        }else{
          Video.enableLobbyView();
        }
        muteParticipants.renderMuteButtons();
        // Video.stealFocus.renderPullFocusButtons();
        console.log(`LEFT ***`);
        if (afterleave) {
            afterleave();
        }else{
            c.userSpaceStatusChanged('left');
        }
    }

    unFocusAll() {
        let c = this;
        if (!c.myConversation) {
            return;
        }
        console.log(`Function: unFocusAll()`);
        let myid = room.myUserId();
        $.each(
            c.conversations[c.myConversation].participants,
            function (pid, p) {
                if (p.participant != myid) {
                    if (
                        Video.videos[p.participant] &&
                        Video.focused[p.participant]
                    ) {
                        Video.videos[p.participant].focusButton.removeClass(
                            "active"
                        );
                        Video.videos[p.participant].focusButton.attr(
                            "title",
                            "Focus"
                        );
                        Video.videos[p.participant].focusButton.attr(
                            "data-original-title",
                            "Focus"
                        );
                        Video.unFocusVideo(p.participant);
                    }
                }
            }
        );
    }

    unFocusNonConvo(exclude = [],space_id='') {
        let c = this;
        console.log("Called unfocus all participants");
        $.each(Video.focused, function (pid, value) {
            //check if focused participant exists on videos object
            if (
                Video.videos[pid] &&
                Video.focused[pid] &&
                !exclude.includes(pid)
            ) {
                //condition to remove focus only participants that are not in my conversation
                if (
                    c.myConversation == null ||
                    c.isOnConversation(pid) != c.myConversation
                ) {
                    Video.videos[pid].focusButton.removeClass("active");
                    Video.videos[pid].focusButton.attr("title", "Focus");
                    Video.videos[pid].focusButton.attr(
                        "data-original-title",
                        "Focus"
                    );
                    Video.unFocusVideo(pid,false,space_id);
                }
            }
        });
    }

    //appends participant html to conversation

    appendParticipant(participant, el = null) {
        console.log(`Function: appendParticipant(participant:${participant})`);
        let c = this;
        if (!participant.participant || (!Video.videos[participant.participant] && participant.participant != room.myUserId())) {//card 760
            return;
        }
        if(Video.isLobbyView && participant.conversation_id!=c.myConversation && (participant.participant != room.myUserId() || room==null)){
            Video.speaker.removeSpeaker(participant.participant);
            Video.removeParticipantFromLobby(participant.participant);
        }
        let videoElement = $("<video/>", {
            autoplay: 1,
            pid: participant.participant, //card 599
            class: "h-100 video-center video-preview conversation-video-player", //card 599
            muted: 1,
        });
        //console.log("Preview video participant id:"+ participant.participant,room.getParticipantById(participant.participant));
        console.log(
            `Comparing my id (${room.myUserId()}) with participant id (${
                participant.participant
            })`
        );
        if (participant.participant == room.myUserId()) {
            c.myConversation = participant.conversation_id;
            c.conversations[c.myConversation].htmlElement.addClass(
                "my-conversation"
            );
        }
        let previewVideo = null;
        try {
            previewVideo =
                participant.participant != room.myUserId()
                    ? Video.getParticipantVideo(participant.participant)
                    : getLocalMainKinoTrack();
        } catch (e) {
            console.log(e);
        }
        if (previewVideo) {
            videoElement[0].srcObject = previewVideo.stream;
            videoElement[0].oncanplay = function () {
                videoElement[0].play();
            };
        }



        let displayName = $('<div/>', {
            class: `position-absolute pl-4 pr-1 w-100 top-text noselect display-name-${participant.participant}`,
            html: participant.displayName
        });

        let vidcontainer = $("<div/>", {
            class: "col-12 pl-0 pr-0 participant-container text-center",
            html: [displayName, videoElement],
        });

        let container = $("<div/>", {
            class: `col-6 pl-0 pr-0 pid_${participant.participant}`,
            html: [vidcontainer],
        });

        el.append(container);
        if (
            c.conversations[participant.conversation_id].participants.length >
            c.showExpandLimit
        ) {
            c.conversations[participant.conversation_id].expandBtn.addClass(
                "expand"
            );
        }
        if (participant.conversation_id == c.myConversation) {
            c.updateBanner();
        }


        c.changeConversationOrder(participant.conversation_id);
    }

    sortConversations() {
        setTimeout(() => {
            console.log("_conversations_sorted");
            $("#pinned-convo-container > .conversation-container").each(
                (i, el) => {
                    let order = 1;
                    try {
                        if (
                            $(el).find(".conversation-tiles").children().length
                        ) {
                            order = 0;
                        }
                    } catch (error) {}
                    $(el).css("order", order);
                }
            );
        }, 1500);
    }

    changeConversationOrder(conversationId) {
        // console.log();
        // if(this.conversations[conversationId]){
        //     this.conversations[conversationId].container.css("order",this.conversations[conversationId].participants.length ? 0 : 1);
        // }
        // $(`#pinned-convo-container [data-id=${conversationId}]`).css(
        //     "order",
        //     $(
        //         `#pinned-convo-container [data-id=${conversationId}] .conversation-tiles`
        //     ).children().length
        //         ? 0
        //         : 1
        // );
    }

    updateVideoStream(pid) {
        let c = this;
        //card 599
        screenShare.popup.updateVideoStream(pid);
        Video.splitConversations.updateVideoStream(pid);
        // if (!spacesView.isOpen()) {
        //     return;
        // }
        //end card 599
        console.log("Called update video stream on conversations");
        let participant=kinoParticipants.get(pid);
        if(participant){
            let space_id=participant.getSpaceId();
            let videoStream=participant.getVideo();
            if(!videoStream){return}
            if(space_id){
                let pHtml = c.conversations[space_id].container.find(
                    `.pid_${pid}`
                );
                let menuPhtml = c.conversations[space_id].leftSpaceMenu.find(`.pid_${pid}`)
                let videoElement = pHtml.find("video");
                let menuVideoElement = menuPhtml.find("video")
                if(videoElement && videoElement[0]){
                    // console.log("Current src object",videoElement[0].srcObject);
                    if(videoElement[0].srcObject){
                        try {
                            // console.log("Video track of user",videoElement[0].srcObject.getVideoTracks()[0]);
                            // console.log("Video track resumed",videoStream.stream.getVideoTracks()[0]);
                            let currentTrack=videoElement[0].srcObject.getVideoTracks()[0];
                            let newTrack=videoStream.stream.getVideoTracks()[0];
                            if(currentTrack.id == newTrack.id){
                                return;
                            }
                        } catch (error) {
                            console.log("Resume video on spaces view error",error);
                        }

                    }
                    videoElement[0].srcObject =  videoStream.stream;
                    videoElement[0].oncanplay = function () { videoElement[0].play(); };
                }
                if(menuVideoElement && menuVideoElement[0]){
                    menuVideoElement[0].srcObject = videoStream.stream
                    menuVideoElement[0].oncanplay = function () { menuVideoElement[0].play(); };
                }
            }else{
                let pHtml = spacesView.lobbyTiles.find(
                    `.pid_${pid}`
                );
                let menuPhtml = spacesView.leftSpaceMenu.find(`.pid_${pid}`)
                let videoElement = pHtml.find("video");
                let menuVideoElement = menuPhtml.find("video")
                if(videoElement && videoElement[0]){
                    videoElement[0].srcObject =  videoStream.stream;
                    videoElement[0].oncanplay = function () { videoElement[0].play(); }
                }
                if(menuVideoElement && menuVideoElement[0]){
                    menuVideoElement[0].srcObject =  videoStream.stream;
                    menuVideoElement[0].oncanplay = function () { menuVideoElement[0].play(); }
                }
            }
        }

    }

    participantDisconnected(pid) {
        console.log(`Function: participantDisconnected(participant:${pid})`);
        let c = this;
        $.each(c.conversations, function (i, conversation) {
            $.each(c.conversations[i].participants, function (j, p) {
                //one person convo fix
                if (typeof p == "undefined") {
                    return;
                }
                if (p.participant == pid) {
                    //found participant
                    c.removeParticipant(i, pid);
                }
            });
        });
    }

    newConversation(conversation,fromSocket=false) {
        var c = this;
        if(c.conversations[conversation.id]){
            console.log(`space already exists`)
            return;
        }
        console.log("Creating new conversation", conversation);
        let id=conversation.id;
        let participantsToArray =
            typeof conversation.participants == "object"
                ? Object.values(conversation.participants)
                : new Array(...conversation.participants);
        c.conversations[id]=new Space(conversation.id,conversation.name,conversation.conv_type);
        console.log("New space ",c.conversations[id]);
        if(conversation.is_private){
            c.conversations[id].setPrivate(true,conversation.made_private_by);
        }
        c.conversations[id].setPinned(conversation?.pinned);
        c.conversations[id].addToNewPanel();
        c.conversations[id].setParticipants(participantsToArray,participantsToArray.length==2 && fromSocket);
        return c.conversations[id];
    };

    newEmptyConversation(id, participants = []) {
        let c = this;
        if (c.conversations[id] !== undefined) {
            console.log(
                "creating empty conversation, conversation exist-- adding participant:",
                c.conversations[id]
            );

            c.conversations[id].setParticipants(participants);
        } else {

            c.conversations[id]=new Space(id,"Focused Space",'temporary');
        }

        return c.conversations[id];
    }

    createLobbySpace(){
        if (this.conversations[-1] === undefined) {
            this.conversations[-1]=new Space(-1,"Lobby",'pinned');
        }
    }

    appendConversation(conversation) {
        let c = this;
        console.log("appending conversation:", conversation);
        let row = $("<div/>", {
            class: "row conversation-tiles",
        });
        let expand = $("<button/>", {
            class: `expand-btn`,
            html: `<i class="fas fa-caret-down pe-none"></i>`,
        }).on("click", function () {
            if ($(this).hasClass("expanded")) {
                $(this).html(`<i class="fas fa-caret-down pe-none"></i>`);
                $(this).removeClass("expanded");
                $(this).parent().find(".c-wrapper").removeClass("expanded"); //.css('max-height', '197px');
            } else {
                $(this).html(`<i class="fas fa-caret-up pe-none"></i>`);
                $(this).addClass("expanded");
                $(this).parent().find(".c-wrapper").addClass("expanded"); //.css('max-height', 'unset');
            }
        });

        let leavebtn = $("<button/>", {
            class: `btn btn-sm btn-outline-danger btn-rounded mt-1 leave-conversationBtn noselect`,
            html: `Leave Space`
        }).on('click', function () {
            if(lockFocus.isLocked() && !permissions.hasSpacesLock()) {
                c.isJoining=false;
                lockFocus.showLockFocusNotification();
                return;
            }
            if (!c.isJoining) {
                c.userSpaceStatusChanged('leaving');
                c.leave();
            }
        });
        let myconversationOverlay = $("<div/>", {
            class: "conversation-overlay",
            html: leavebtn,
        });

        let cname = conversation.name;
        if (!conversation.name || conversation.name.length == 0) {
            cname = conversation.conv_type=="pinned" ? "Pinned Space" : "Focused Space";
        }
        let conversationName = $("<div/>", {
            class: "conversation-name",
            tabindex: 0,
            html: cname,
        })
            .on("click", (event) => {
                namePinContainer.addClass("editNameStaticOpacity"); // card id 836
                if (!$(event.currentTarget).hasClass("editing")) {
                    c.makeNameEditable(conversation.id);
                }
            })
            .on("paste", (e) => {
                let conv_name = sanitizeHtml(
                    conversationName.html(),
                    this.sanitizeOptions
                );
                if (
                    (conv_name + event.clipboardData.getData("text/plain"))
                        .length >= 30
                ) {
                    return false;
                }
            })
            .on("keypress", (e) => {
                let code = e.keyCode || e.which;
                if (code == 13) {
                    c.saveName(conversation.id);
                }
                let conv_name = sanitizeHtml(
                    conversationName.html(),
                    this.sanitizeOptions
                );
                if (
                    conv_name.length > 30 &&
                    window.getSelection().toString().length === 0
                ) {
                    if (
                        code != 8 &&
                        code != 9 &&
                        code != 37 &&
                        code != 39 &&
                        !(code == 88 && e.ctrlKey)
                    ) {
                        e.preventDefault();
                        return false;
                    }
                }
            })
            .on("focusout", function (e) {
                if ($(document.activeElement).hasClass("conversation-name"))
                    return false; // card 441
                this.makeNameEditableMouseOutTimeout = setTimeout(() => {
                    if (!c.conversations[conversation.id].isSaving) {
                        c.cancelNameChange(conversation.id);
                        namePinContainer.removeClass("editNameStaticOpacity"); // card id 836
                    }
                }, 500);
            });

        c.conversations[conversation.id].conversationName = conversationName;

        let startediting = $("<span/>", {
            class: "start-edit",
            html: `<i class="fas fa-pen"></i>`,
            title: "Edit space name",
            "data-toggle": "tooltip",
            "data-placement": "top",
        }).on("click", function () {
            c.conversations[conversation.id].isSaving = false;
            c.makeNameEditable(conversation.id);
            namePinContainer.addClass("editNameStaticOpacity"); // card id 836
        });

        let savename = $("<span/>", {
            class: "save-name",
            html: `<i class="fas fa-check"></i>`,
        }).on("click", function () {
            console.log("It works");
            c.conversations[conversation.id].isSaving = true;
            c.saveName(conversation.id);
            namePinContainer.removeClass("editNameStaticOpacity"); // card id 836
        });

        let cancelname = $("<span/>", {
            class: "cancel-name",
            html: `<i class="fas fa-times"></i>`,
        }).on("click", function () {
            c.conversations[conversation.id].isSaving = false;
            c.cancelNameChange(conversation.id);
            namePinContainer.removeClass("editNameStaticOpacity"); // card id 836
        });

        let cnameAction = $("<div/>", {
            class: "name-action",
            html: [startediting, savename, cancelname],
        });

        // card id 836
        let namePinContainer = $("<div/>", {
            class: "name-pin",
            html: [cnameAction, c.conversations[conversation.id].pinAction],
        });
        // end card id 836

        let cnameContainer = $("<div/>", {
            class: "conversation-name-container",
            html: [
                c.conversations[conversation.id].conversationName,
                // cnameAction,
                namePinContainer,
            ],
        });
        c.conversations[conversation.id].expandBtn = expand;
        c.conversations[conversation.id].pinMarker = $("<div/>", {
            class: "pinned-conversation-marker",
            html: conversation.conv_type === "pinned" ? c.pinIcon : "",
        });
        let divconv = $('<div/>', {
                class: "col-12 conversation c-wrapper",
                html: [c.conversations[conversation.id].pinMarker,row, myconversationOverlay]
            }).on('dblclick',function(){
                if(Video.isDisconnected){
                    return;
                }
                if(lockFocus.isLocked() && !c.isModerator()){
                    c.isJoining=false;
                    c.setJoining(false);
                    lockFocus.showLockFocusNotification();
                    return;
                }

                //begin card 529
                try {
                    if (
                        c.conversations[conversation.id].is_private &&
                        c.myConversation != conversation.id &&
                        !c.isJoining
                    ) {
                        if (c.isModerator()) {
                            c.userSpaceStatusChanged('joining');
                            if (c.myConversation) {
                                c.isJoining = true;
                                c.leave(() => {
                                    c.joinPrivateSpaceAsModerator(
                                        conversation.id
                                    );
                                });
                            } else {
                                c.joinPrivateSpaceAsModerator(conversation.id);
                            }

                            return;
                        }
                        c.setJoining(false); //card 758
                        c.showNotification(
                            '<i class="fas fa-lock fa-lg" style="color:#fff"></i>',
                            "CONVERSATION_IS_PRIVATE",
                            { conversation_id: conversation.id }
                        );
                        return;
                    }
                } catch (error) {}
                //end card 529
                if (c.myConversation && c.myConversation != conversation.id) {
                    if (!c.isJoining) {
                        c.isJoining = true;
                        c.setJoining(true, conversation.id);
                        c.userSpaceStatusChanged('joining');
                        c.leave(() => {
                            setTimeout(() => {
                                c.join(conversation.id);
                            }, 1200);
                        });
                    } else {
                        console.log("isJoining");
                    }
                } else if (!c.myConversation) {
                    //card 529
                    if (!c.isJoining) {
                        c.isJoining = true;
                        c.setJoining(true, conversation.id);
                        c.userSpaceStatusChanged('joining');
                        setTimeout(() => {
                            c.join(conversation.id);
                        }, 500);
                        // c.join(conversation.id);
                    } else {
                        console.log("isJoining");
                    }
                }
            })
            .on("mouseover", function () {
                if (conversation.id == c.myConversation) {
                    if(Video.isDisconnected){return}
                    myconversationOverlay.addClass("visible");
                } else {
                    myconversationOverlay.removeClass("visible");
                }
            })
            .on("mouseleave", function () {
                if (myconversationOverlay.hasClass("visible")) {
                    myconversationOverlay.removeClass("visible");
                }
            });
        c.conversations[conversation.id].pinAction = $("<div/>", {
            class: "pinned-conversation-icon",
            html: conversation.conv_type === "pinned" ? c.unpinIcon : c.pinIcon,
            title:
                conversation.conv_type === "pinned"
                    ? "Unpin this space"
                    : "Pin this space",
            "data-placement": "top",
            "data-toggle": "tooltip",
        }).on("click", function (e) {
            e.stopPropagation();
            namePinContainer.removeClass("name-pin-opacity");
            if (conversation.conv_type === "pinned") {
                c.unPinConversation(conversation.id);
            } else {
                c.pinConversation(conversation.id);
            }
        });

        let convo = $("<div/>", {
            class: "col-6 mb-5 conversation-container",
            "data-id": conversation.id,
            style: `order: ${conversation.participants.length ? 0 : 1}`,
            html: [cnameContainer, divconv, expand],
        }) // card id 836
            .on("mouseover", function () {
                namePinContainer.addClass("name-pin-opacity");
            })
            .on("mouseleave", function () {
                namePinContainer.removeClass("name-pin-opacity");
            });
        // end card id 836

        if (ROLE == "moderator" || this.host == 1) {
            // cnameContainer.append(c.conversations[conversation.id].pinAction);
            namePinContainer.append(c.conversations[conversation.id].pinAction); // card id 836
        } else {
            c.conversations[conversation.id].pinAction = null;
        }
        c.conversations[conversation.id].htmlElement = convo;
        $.each(conversation.participants, function (i, participant) {
            //append participant element to conversation
            c.appendParticipant(participant, row);
            //begin card 744
            if (conversation.id != c.myConversation) {
                //card 730
                Video.changeParticipantVolume(
                    participant.participant,
                    0.05,
                    true
                );
            }
            //end card 744
        });
        if (conversation.conv_type == "pinned") {
            c.pinnedConversationContainer.prepend(convo);
        } else {
            c.container.append(convo);
        }
        //begin card 529
        if (c.conversations[conversation.id].is_private) {
            $.each(conversation.participants, function (i, participant) {
                if ( participant.thumbnail &&  Video && Video.videos[participant.participant] ) {
                    Video.videos[participant.participant].thumbnail =
                        participant.thumbnail;
                    c.updateThumbnailImage(participant.participant);
                    c.updateConversationThumbnail(participant.participant);
                    Video.videos[participant.participant].onPrivateSpaceStarted();
                }
            });
        }
        //end card 529
    }

    selectText(element) {
        var text = element[0];
        if (document.body.createTextRange) {
            var range = document.body.createTextRange();
            range.moveToElementText(text);
            range.select();
        } else {
            var selection = window.getSelection();
            var range = document.createRange();
            range.selectNodeContents(text);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }

    showNotification(icon, type, data = {}, text = "") {
        var c = this;
        // console.error(data);
        if(data && $(`#${data.participant}-notification`)){
            $(`#${data.participant}-notification`).remove();
        }

        let icondiv = $("<div/>", {
            class: "icon",
            html: icon,
        });
        let action = "";
        let action2 = "";
        let dismiss = "";
        let space = "&nbsp;";
        let closediv = $("<div/>", {
            class: "close",
            html: `<i class="icofont-close icofont-1x"></i>`,
        });
        let notificationTimeout = 10000;
        console.log("Show notification for " + type);
        let is_private = false;
        switch (type) {
            case "JOIN_CONVERSATION":
                try {
                    socket.sendInviteCanceled();
                } catch (err) {
                    console.log(err);
                }
                //begin card 529
                try {
                    if (
                        c.conversations[data.conversation_id] &&
                        c.conversations[data.conversation_id].is_private
                    ) {
                        is_private = true;
                    }
                } catch (error) {}
                //end card 529
                text = `${data.displayName} is in a space`;
                action = $('<button/>', {
                    class: 'btn btn-sm btn-light btn-rounded mr-1',
                    html:is_private && permissions.shouldRequestToJoinPrivateSpace() ? 'Ask to join' : 'Enter Space',//card 529
                }).on('click', function () {
                    if(c.isJoining){return}
                    //begin card 529
                    // c.userSpaceStatusChanged('joining');
                    if (is_private) {
                        if (!permissions.shouldRequestToJoinPrivateSpace()) {
                            c.joinSpace(data.conversation_id);
                        } else {
                            c.sendConversationJoinRequest(data.conversation_id);
                        }
                    } else {
                        c.joinSpace(data.conversation_id);
                    }
                    //end card 529
                    closediv.click();
                });
                console.log(data.conversation_id)
                action2 = $("<button/>", {
                    class: "btn btn-sm btn-outline-light btn-rounded mr-1",
                    html: "Invite to Space",
                }).on("click", function () {
                    socket.sendConversationJoinInvite(data.participant, "new");
                    closediv.click();
                    c.showNotification(
                        Video.conversationIcon,
                        "INVITE_WAITING_RESPONSE",
                        {
                            participant: data.participant,
                            conversation_id: data.conversation_id,
                            displayName: data.displayName,
                        }
                    );
                });
                dismiss = $("<button/>", {
                    class: "btn btn-sm btn-outline-danger btn-rounded",
                    html: "Dismiss",
                }).on("click", () => {
                    closediv.click();
                });

                break;
            case "FOCUS_OR_INVITE":
                text = `Leave space and join ${data.displayName}'s space?`;
                action = $("<button/>", {
                    class: "btn btn-sm btn-light btn-rounded mr-1",
                    html: "Leave and Join",
                }).on("click", function () {
                    closediv.click();
                    //check if on stage is active
                    if(onStage.isActive()){
                        onStage.showLockOnStageActiveNotification();
                        return;
                    }
                    if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
                        lockFocus.showLockFocusNotification();
                        return
                    };
                    c.userSpaceStatusChanged('leaving');
                    c.leaveSpace().then(()=>{
                        console.log('left the space to join in lobby');
                    });
                    // c.userSpaceStatusChanged('leaving');
                    // c.leaveSpace().then(() => {
                    //     Video.focusVideo(data.participant, "private", false);
                    //     // c.userSpaceStatusChanged('left');
                    // });
                });
                action2 = $("<button/>", {
                    class: "btn btn-sm btn-outline-light btn-rounded mr-1",
                    html: "Invite to Space",
                }).on("click", () => {
                    //begin card 529
                    if (
                        c.myConversation &&
                        c.private &&
                        c.private.id == c.myConversation
                    ) {
                        c.private.sendJoinConversationInvite(data.participant);
                    } else {
                        socket.sendConversationJoinInvite(
                            data.participant,
                            c.myConversation
                        );
                    }

                    //end card 529
                    closediv.click();
                    c.showNotification(
                        Video.conversationIcon,
                        "INVITE_WAITING_RESPONSE",
                        {
                            participant: data.participant,
                            conversation_id: data.conversation_id,
                            displayName: data.displayName,
                        }
                    );
                    console.log(data);
                    c.notifyOtherParticipants(c.myConversation, data.displayName, data.participant);
                });
                dismiss = $("<button/>", {
                    class: "btn btn-sm btn-outline-danger btn-rounded",
                    html: "Dismiss",
                }).on("click", () => {
                    closediv.click();
                });
                break;
            case "INVITE_TO_NEW_SPACE":
                    text = `Invite ${data.displayName} to a Focused Space? `;

                    action = $("<button/>", {
                        class: "btn btn-sm btn-outline-light btn-rounded mr-1",
                        html: "Invite",
                    }).on("click", () => {
                        //begin card 529
                        if (
                            c.myConversation &&
                            c.private &&
                            c.private.id == c.myConversation
                        ) {
                            c.private.sendJoinConversationInvite(data.participant);
                        } else {
                            socket.sendConversationJoinInvite(
                                data.participant,
                                "new"
                            );
                        }

                        //end card 529
                        closediv.click();
                        c.showNotification(
                            Video.conversationIcon,
                            "INVITE_WAITING_RESPONSE",
                            {
                                participant: data.participant,
                                conversation_id: data.conversation_id,
                                displayName: data.displayName,
                            }
                        );
                        // console.log(data);
                        // c.notifyOtherParticipants(c.myConversation, data.displayName, data.participant);
                    });
                    dismiss = $("<button/>", {
                        class: "btn btn-sm btn-outline-danger btn-rounded",
                        html: "Dismiss",
                    }).on("click", () => {
                        closediv.click();
                    });
                    break;
            case "INVITE_OR_LEAVE":
                text = `Invite ${data.displayName} to a new Focused Space? `;
                    const inviteAllowed=kinoParticipants.inMySpace(true).length  > 2;
                    action = $("<button/>", {
                        class: `btn btn-sm btn-light btn-rounded mr-1 ${inviteAllowed ? '' : 'button-disabled'}`,
                        html: "Invite",
                    }).on("click", () => {
                        if(!inviteAllowed){
                            return
                        }
                        socket.sendConversationJoinInvite(
                            data.participant,
                            "new"
                        );
                        closediv.click();
                        c.showNotification(
                            Video.conversationIcon,
                            "INVITE_WAITING_RESPONSE",
                            {
                                participant: data.participant,
                                conversation_id: data.conversation_id,
                                displayName: data.displayName,
                            }
                        );
                    });
                    action2 = $("<button/>", {
                        class: "btn btn-sm btn-outline-light btn-rounded mr-1",
                        html: "Leave Space",
                    }).on("click",()=>{
                        if(permissions.leaveFallbackAssigned()
                        && permissions.initialSpace()
                        && c.spaceExists(permissions.initialSpace())
                        && permissions.initialSpace() != c.myConversation){
                            c.joinSpace(permissions.initialSpace());
                        }else{
                            c.leaveSpace();
                        }
                        closediv.click();
                    });

                    dismiss = $("<button/>", {
                        class: "btn btn-sm btn-outline-danger btn-rounded",
                        html: "Dismiss",
                    }).on("click", () => {
                        closediv.click();
                    });
                    break;
            case "JUMP_TO_OTHER_CONVO":
                //begin card 529
                try {
                    if (
                        c.conversations[data.conversation_id] &&
                        c.conversations[data.conversation_id].is_private
                    ) {
                        is_private = true;
                    }
                } catch (error) {}
                //end card 529
                text = `Leave space and join ${data.displayName}'s space?`;
                action = $('<button/>', {
                    class: 'btn btn-sm btn-light btn-rounded mr-1',
                    html:is_private && permissions.shouldRequestToJoinPrivateSpace() ? 'Ask to join' : 'Leave and Join',//card 529
                }).on('click', function () {
                    if(c.isJoining){return}
                    closediv.click();
                    //check if on stage is active
                    if(onStage.isActive()){
                        onStage.showLockOnStageActiveNotification();
                        return;
                    }
                    if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
                        lockFocus.showLockFocusNotification();
                        return
                    };
                    //begin card 755
                    if (c.myConversation == data.conversation_id) {
                        return;
                    }
                    //end card 755
                    //begin card 529
                    if (is_private) {
                        if (!permissions.shouldRequestToJoinPrivateSpace()) {
                            c.joinSpace(data.conversation_id);
                        } else {
                            c.sendConversationJoinRequest(data.conversation_id);
                        }
                    } else {
                        c.joinSpace(data.conversation_id);
                    }
                    //end card 529
                });
                action2 = $("<button/>", {
                    class: "btn btn-sm btn-outline-light btn-rounded mr-1",
                    html: "Invite to Space",
                }).on("click", function () {
                    //begin card 529
                    if (
                        c.myConversation &&
                        c.private &&
                        c.private.id == c.myConversation
                        ) {
                            c.private.sendJoinConversationInvite(data.participant);
                    } else {
                        socket.sendConversationJoinInvite(
                            data.participant,
                            c.myConversation,
                            false
                        );
                    }
                    //end card 529
                    closediv.click();
                    c.showNotification(
                        Video.conversationIcon,
                        "INVITE_WAITING_RESPONSE",
                        {
                            participant: data.participant,
                            conversation_id: data.conversation_id,
                            displayName: data.displayName,
                        }
                    );
                    console.log(data);
                    c.notifyOtherParticipants(c.myConversation, data.displayName);
                });
                dismiss = $("<button/>", {
                    class: "btn btn-sm btn-outline-danger btn-rounded",
                    html: "Dismiss",
                }).on("click", () => {
                    closediv.click();
                });

                break;
            case "JOIN_CONVERSATION_INVITE":
                try {
                    Video.sounds.play("wave2");
                } catch (e) {}
                text = `${data.displayName} invited you to a space`;
                action = $("<button/>", {
                    class: "btn btn-sm btn-light btn-rounded mr-1",
                    html: "Enter Space",
                }).on("click", function () {
                    if(c.isJoining){return}
                    //check if on stage is active
                    if(onStage.isActive()){
                        onStage.showLockOnStageActiveNotification();
                        return;
                    }
                    if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
                        lockFocus.showLockFocusNotification();
                        return
                    };
                    // let pRole = room.getParticipantById(data.from).getProperty("role");
                    // let isMod = false;
                    // if(pRole == 'moderator' || pRole == 'host'){
                    //     isMod = true;
                    // }
                    closediv.click();
                    //begin card 755
                    if (
                        c.myConversation &&
                        c.myConversation == data.conversation_id
                    ) {
                        return;
                    }
                    c.joinSpace(data.conversation_id,false,data.id_token);
                });
                action2 = $("<button/>", {
                    class: "btn btn-sm btn-outline-light btn-rounded",
                    html: "Decline",
                }).on("click", () => {
                    closediv.click();
                    socket.sendConversationJoinInviteResponse(data, "declined");
                });

                dismiss = $("<button/>", {
                    class: "btn btn-sm btn-outline-danger btn-rounded",
                    html: "Dismiss",
                }).on("click", () => {
                    closediv.click();
                    // socket.sendConversationJoinInviteResponse(data, 'declined');
                });

                break;
            case "JOIN_NEW_CONVERSATION_INVITE":
                try {
                    Video.sounds.play("wave2");
                    socket.sendInviteCanceled();
                } catch (e) {}
                text = `${data.displayName} invited you to a space`;
                action = $("<button/>", {
                    class: "btn btn-sm btn-light btn-rounded mr-1",
                    html: "Enter Space",
                }).on("click", function () {
                    console.log("Clicked Enter space")
                    //check if on stage is active
                    if(onStage.isActive()){
                        onStage.showLockOnStageActiveNotification();
                        return;
                    }
                    let pRole = room.getParticipantById(data.from).getProperty("role");
                    let isMod = false;
                    if(pRole == 'moderator' || pRole == 'host'){
                        isMod = true;
                    }
                    if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
                        lockFocus.showLockFocusNotification();
                        return
                    };
                    closediv.click();
                    if (data.is_new === true) {
                        console.log("Is new space")
                        if (c.isOnConversation(data.from)) {
                            console.log("Focusing on user")
                            if(c.myConversation){
                                c.leaveSpace().then(()=>{
                                    console.log('left the space to focus user');
                                    Video.focusVideo(data.from, "autoFocusMe", false,false,true);
                                });
                            }else{
                                Video.focusVideo(data.from, "private", false,false,true);
                            }
                        } else {
                            if(c.isOnConversation(room.myUserId())){
                                c.userSpaceStatusChanged('leaving');
                                c.leaveSpace().then(()=>{
                                    console.log('left the space to join in lobby');
                                });
                            }else{
                                Video.focusVideo(data.from, "autoFocusMe", false);
                            }
                        }
                    } else {
                        //begin card 755
                        if (
                            c.myConversation &&
                            c.myConversation == data.conversation_id
                        ) {
                            return;
                        }
                        c.joinSpace(data.conversation_id);
                    }
                });

                action2 = $("<button/>", {
                    class: "btn btn-sm btn-outline-light btn-rounded",
                    html: "Decline",
                }).on("click", () => {
                    closediv.click();
                    socket.sendConversationJoinInviteResponse(data, "declined");
                });

                dismiss = $("<button/>", {
                    class: "btn btn-sm btn-outline-danger btn-rounded",
                    html: "Dismiss",
                }).on("click", () => {
                    closediv.click();
                    // socket.sendConversationJoinInviteResponse(data, 'declined');
                });

                break;
            case "JOIN_CONVERSATION_INVITE_RESPONSE":
                //fix
                if (
                    data.conversation_id == c.isOnConversation(data.participant)
                ) {
                    return;
                }
                notificationTimeout = 5000;
                text = `${data.displayName} is unavailable to join the space`;

                dismiss = $("<button/>", {
                    class: "btn btn-sm btn-outline-danger btn-rounded",
                    html: "Dismiss",
                }).on("click", () => {
                    closediv.click();
                });
                break;
            case "INVITE_WAITING_RESPONSE":
                notificationTimeout = 5000;
                text = `Waiting for ${data.displayName} to Enter`;

                dismiss = $("<button/>", {
                    class: "btn btn-sm btn-outline-danger btn-rounded",
                    html: "Dismiss",
                }).on("click", () => {
                    closediv.click();
                });
                break;
            //begin code card ID: 529
            case "CONVERSATION_IS_PRIVATE":
                $(`#notificationsBanner`)
                    .find(".CONVERSATION_IS_PRIVATE")
                    .remove();
                text = `This space is private`;
                action = $("<button/>", {
                    class: "btn btn-sm btn-light btn-rounded mr-1",
                    html: !permissions.shouldRequestToJoinPrivateSpace() ? "Enter Space" : "Ask to join",
                }).on("click", function () {
                    //c.getModeratorToken(data.conversation_id);
                    if (permissions.shouldRequestToJoinPrivateSpace()) {
                        c.sendConversationJoinRequest(data.conversation_id);
                    } else {
                        if(c.isJoining){return}
                        c.joinSpace(data.conversation_id);
                    }
                    closediv.click();
                });
                dismiss = $("<button/>", {
                    class: "btn btn-sm btn-outline-danger btn-rounded",
                    html: "Dismiss",
                }).on("click", () => {
                    closediv.click();
                });
                break;
            case "CONVERSATION_REQUEST_REJECTED":
                notificationTimeout = 5000;
                text = `Your request to join on a private conversation was not accepted`;

                dismiss = $("<button/>", {
                    class: "btn btn-sm btn-outline-danger btn-rounded",
                    html: "Dismiss",
                }).on("click", () => {
                    closediv.click();
                });
                break;
            case "JOIN_SPLIT_CONVERSATION_FORCE":
                //join sound
                // console.error('SPLIT FORCE DATA', data)
                if(data.playNotificationSound){
                    try {Video.sounds.play('wave2');}catch(e){}
                }
                let seconds=$("<span/>",{
                    html:10
                });
                notificationTimeout = data.showNotification ? 10000 : 0;
                let initSeconds = data.showNotification ? 10 : 0;
                let splitFrom = data.from == room.myUserId() ? "You" : data.displayName;
                let forceMsg=``;
                clearInterval(c.countDownInterval);
                c.countDownInterval = setInterval(() => {
                    initSeconds--;
                    seconds.html(initSeconds);
                    console.log(initSeconds);
                    if(initSeconds<=0){
                        clearInterval(c.countDownInterval);
                        if(spacesView.isOpen()){
                            spacesView.hideSpaceView();
                        }
                        permissions.isWorkspace && permissions.setSetting('mute_chatter',data.masterVolume==0)
                        let muteVolume=data.masterVolume===0;
                        // if(permissions.isWorkspace && !permissions.shouldMuteChatter()){
                        //     mv=false;
                        // }
                        if(muteVolume && (!permissions.isWorkspace || (permissions.isWorkspace && permissions.shouldMuteChatter()))){
                            volumeManager.muteVolumeOverwrite=true;
                            volumeManager.muteChatter();
                        }else if(!muteVolume && volumeManager.muteVolumeOverwrite){
                            volumeManager.unMuteChatter();
                        }
                        if(!data.conversation_id){
                            animatedLayers.movingIntoSpacesLayer();
                            c.leaveSpace(false);
                            return;
                        }
                        if(c.myConversation && c.myConversation==data.conversation_id){
                            c.userSpaceStatusChanged('left');
                            return;
                        }
                        c.joinSpace(data.conversation_id,false,data.id_token ? data.id_token :false);
                        animatedLayers.movingIntoSpacesLayer();
                    }
                }, 1000);
                forceMsg= data.from != room.myUserId() ? `${data.displayName} is moving you to a space in `: `Move to spaces in `;
                if(data.data && data.data.recurring){
                forceMsg=`Shuffling spaces in `
                }
                text=$('<span/>',{
                    html:[forceMsg,seconds,` seconds`]
                });
                $(".notificationContent.JOIN_SPLIT_CONVERSATION_FORCE").remove();
                break;
            default:
                return;
                break;
        }

        let textdiv = $("<div/>", {
            class: "text",
            html: [text, space, action, space, action2, space, dismiss],
        });
        //fix
        let pid =
            type == "JOIN_CONVERSATION_INVITE" ||
            type == "JOIN_NEW_CONVERSATION_INVITE"
                ? data.from
                : data.participant;

        let container = $("<div/>", {
            class: `notificationContent ${pid}-notification ${type} conversation${data.conversation_id}`,
            id: `${pid}-notification`,
            html: [icondiv, textdiv, closediv],
        });

        if (
            type == "INVITE_WAITING_RESPONSE" ||
            type == "JOIN_NEW_CONVERSATION_INVITE" ||
            type == "JOIN_CONVERSATION_INVITE"
        ) {
            c.invitesTimeout[pid] = setTimeout(function () {
                c.hideNotification(container);
                if (
                    type == "JOIN_NEW_CONVERSATION_INVITE" ||
                    type == "JOIN_CONVERSATION_INVITE"
                ) {
                    socket.sendConversationJoinInviteResponse(data, "declined");
                }
            }, notificationTimeout);
        } else {
            let timeout = setTimeout(function () {
                c.hideNotification(container);
            }, notificationTimeout);
        }

        closediv.on("click", function (e) {
            //fix
            if (e.isTrigger === undefined) {
                if (
                    type == "JOIN_NEW_CONVERSATION_INVITE" ||
                    type == "JOIN_CONVERSATION_INVITE"
                ) {
                    socket.sendConversationJoinInviteResponse(data, "declined");
                }
            }
            if (typeof timeout !== "undefined") {
                clearTimeout(timeout);
            }
            if (c.invitesTimeout[pid] !== undefined) {
                clearTimeout(c.invitesTimeout[pid]);
            }
            c.hideNotification(container);
        });
        if(data.showNotification == undefined || data.showNotification || data.inviteType == 'invite' || (type=="SPLIT_SPACES_SETTINGS_CHANGED" && !data.data.recurring)){
            container.appendTo(Video.notifications);
        }
    }

    hideNotification(notification) {
        $(notification).remove();
    }

    //pinned conversations
    createPinnedConversation(conversation_name) {
        return new Promise(async (resolve,reject)=>{
            if (!conversation_name) {
                reject()
                return;
            }
             axios.post(convertPath("/conversation/create"), {
                        name: conversation_name,
                        room_id: this.room_id,
                        conv_type: "pinned",
                    }, await electronConfig())
                    .then((res) => {
                        let conversation = res.data;
                        if (conversation.id) {
                            conversation["participants"] = [];
                            socket.sendBroadcastMessage({
                                eventName: "NewPinnedConversation",
                                data: conversation,
                                room_id: room.getName(),
                            });
                            const newSpace = this.newConversation(conversation);
                            resolve(newSpace);
                        } else {
                            reject("Error happened creating space")
                        }
                    })
                    .catch((err) => {
                        reject("Error happened creating space")
                    });

        })

    }

    async unPinConversation(id) {
        var c = this;
        if (!c.canPin()) {
            return;
        }
        c.conversationUnPinned(id);
        socket.sendBroadcastMessage({
            eventName: "ConversationUnpin",
            data: {
                conversation_id: id,
                room_id: room.getName(),
            },
        });
        axios.post(convertPath(`/conversation/unpin/${id}`),{},await electronConfig()).then((response) => {
            if (response.data.status) {
                // console.log(response.data.status);
                $("#add-conversation-modal").modal("hide");
                $("#new-conversation-name-input").val("");
            }
        });
    }
    async pinConversation(id) {
        var c = this;
        if (!c.canPin()) {
            return;
        }
        c.conversationPinned(id);
        socket.sendBroadcastMessage({
            eventName: "ConversationPin",
            data: {
                conversation_id: id,
                room_id: room.getName(),
            },
        });
        axios.post(convertPath(`/conversation/pin/${id}`),{},await electronConfig()).then((response) => {
            if (response.data.status) {
                // console.log(response.data.status);
                $("#add-conversation-modal").modal("hide");
                $("#new-conversation-name-input").val("");
            }
        });
    }

    conversationUnPinned(id) {
        var c = this;
        try {
            c.conversations[id].conv_type = "temporary";
            if (c.conversations[id].pinAction) {
                c.conversations[id].pinAction.html(spacesView.pinIcon);
                c.conversations[id].pinAction.attr({ title: "Pin this space" });
                if(c.conversations[id].pinnedSpace){
                    c.conversations[id].pinnedSpace.html("");
                }
            }
            c.conversations[id].container.removeClass('space-pinned').addClass('space-temporary');
            // c.conversations[id].container.prependTo(c.container);
            c.conversations[id].endFocusedSpace();
            // if (c.conversations[id].participants.length <= 1) {
            //     if (c.myConversation == id) {
            //         c.leave();
            //     } else {
            //         c.removeConversation(id);
            //     }
            // }
        } catch (error) {
            console.warn("unpin error",error);
        }
    }
    conversationPinned(id) {
        var c = this;
        try {
            c.conversations[id].conv_type = "pinned";
            if (c.conversations[id].pinAction) {
                c.conversations[id].pinAction.html(spacesView.unpinIcon);
                c.conversations[id].pinAction.attr({
                    title: "Unpin this space",
                });
            }
            c.conversations[id].container.removeClass('space-temporary').addClass('space-pinned');
            if(c.conversations[id].pinnedSpace){
                c.conversations[id].pinnedSpace.html(spacesView.pinIcon);
            }
            // c.conversations[id].container.prependTo(
            //     c.pinnedConversationContainer
            // );
        } catch (error) {
            console.warn("pin error",error);
        }
    }

    submitNewConversation() {
        var c = this;
        if(!permissions.hasSpacesManager()){
            return
        }
        var conversationName = $("#new-conversation-name-input").val();
        // if(conversationName.length == 0){
        //     c.createPinnedConversation("Default Conversation");
        // }
        c.createPinnedConversation(conversationName);
    }

    canPin() {
        var c = this;
        if (c.host == 1 || ROLE == "moderator") {
            return true;
        } else {
            return false;
        }
    }
    addPinAccess() {
        var c = this;
        console.log("adding pin access");
        c.container.addClass("moderator");
        c.pinnedConversationContainer.addClass("moderator");
        c.createConversationBtn = $("<button/>", {
            class: "btn text-white",
            id: "new-conversation-btn",
            title: "Add pinned space",
            "data-toggle": "tooltip",
            "data-placement": "top",
            html: `<i class="fa fa-plus"></i>`,
        }).on("click", function () {
            $("#add-conversation-modal").modal("show");
            $("#new-conversation-name-input").focus();
        });
        $("#conversation-action-buttons").html(c.createConversationBtn);
        $.each(c.conversations, function (i) {
            if (
                c.conversations[i].pinAction == null ||
                c.conversations[i].pinAction === undefined
            ) {
                c.conversations[i].pinAction = $("<div/>", {
                    class: "pinned-conversation-icon",
                    html:
                        c.conversations[i].conv_type === "pinned"
                            ? c.unpinIcon
                            : c.pinIcon,
                    title:
                        c.conversations[i].conv_type === "pinned"
                            ? "Unpin this space"
                            : "Pin this space",
                    "data-placement": "top",
                    "data-toggle": "tooltip",
                }).on("click", function (e) {

                    e.stopPropagation();

                    c.conversations[i].container.find(".name-pin").removeClass('name-pin-opacity')
                    if (c.conversations[i].conv_type === "pinned") {
                        c.unPinConversation(c.conversations[i].id);
                    } else {
                        c.pinConversation(c.conversations[i].id);
                    }
                    $(this).tooltip('hide');
                });
                c.conversations[i].pinAction.appendTo(
                    c.conversations[i].container.find(
                        ".name-pin"
                    )
                );
            }
        });
    }
    removePinAccess() {
        var c = this;
        c.container.removeClass("moderator");
        c.pinnedConversationContainer.removeClass("moderator");
        c.createConversationBtn.remove();
        $.each(c.conversations, function (i) {
            if (c.conversations[i].pinAction) {
                c.conversations[i].pinAction.off();
                c.conversations[i].pinAction.remove();
                c.conversations[i].pinAction = null;
            }
        });
    }

    aloneConversationVolume(overwriteMasterVolume=false) {
        var c = this;
        //begin card 781
        let masterVolume = overwriteMasterVolume!==false ? overwriteMasterVolume : 0.05;
        if (Video.masterMuted && overwriteMasterVolume===false) {
            masterVolume = 0;
        }
        // Video.masterVolumeSlider.val(masterVolume);
        Video.changeMasterVolume(masterVolume);
        // $(".masterAudioVal").html(`${masterVolume * 100}%`);
        //end card 781
        Video.stateChangedWhileMuted = true; //card 791
    }

    leaveConversationVolume() {
        var c = this;
        //begin card 781
        let masterVolume = 1;
        console.log(`Conversation leave volume ,focused ${Object.keys(Video.focused).length} ,mySpace ${c.myConversation}, masterMuted=${Video.masterMuted},overwrite=${c.masterVolumeOverwrite}`);
        if ((Object.keys(Video.focused).length == 0 && !c.myConversation) && Video.masterMuted && c.masterVolumeOverwrite!==false) {
            masterVolume = 0;
        }
        if((Object.keys(Video.focused).length == 0 && !c.myConversation) && c.masterVolumeOverwrite!==false){
            c.masterVolumeOverwrite=false;
        }

        if(masterVolume==1 && Video.masterMuted && c.masterVolumeOverwrite===false){
            Video.lastMasterVolume=1;
            masterVolume=0;
        }

        // Video.masterVolumeSlider.val(masterVolume);
        Video.changeMasterVolume(masterVolume, masterVolume > 0 ,masterVolume === 0 ? false : 0.05);
        // $(".masterAudioVal").html(`${masterVolume * 100}%`);
        //end card 781
        Video.stateChangedWhileMuted = true; //card 791
    }
    hideErrorMessageConvo() {
        $("#createConvoErrorInner").remove();
    }
    //begin code card ID: 529
    isPrivate(cid) {
        return this.conversations[cid] !== undefined
            ? this.conversations[cid].is_private
            : false;
    }
    isModerator() {
        return HOST == 1 || ROLE == "moderator";
    }
    joinPrivateSpaceAsModerator(cid) {
        this.setJoining(true, cid); //card 758
        console.log("Joining private space",cid)
        this.getModeratorToken(cid).then((token) => {
            this.joinPrivateConversation(cid, token);
        }).catch(err=>{
            this.setJoining(
                true,
                cid,
                "You have no access to join this private space"
            ); //card 758
            this.isJoining = false;
        });
    }
    async getModeratorToken(cid,token=false) {
        return new Promise(async (resolve,reject)=>{
            if(token!==false){
                resolve(token);
                return;
            }
            try {
                axios.post(convertPath(`/conversation/${room.getName()}/${cid}/private/getToken`),
                        {
                            participant_id: room.myUserId(),
                            guest_id: isElectron ? GUEST_ID : '',
                            device_type: isElectron ? 'electron' : ''
                        }, await electronConfig()
                    )
                    .then((res) => {
                        console.log("Moderator token response", res.data);
                        if (res.data && res.data.success) {
                            resolve(res.data.token_id);
                        } else {
                            reject(false);
                        }
                    })
                    .catch((err) => {
                        console.error("Failed to get moderator token", err);
                        reject(err);
                    });
            } catch (error) {
                reject(error);
            }
        });

    }
    makePrivateButtonHandler() {
        if(!permissions.hasPrivateSpaces()){return}
        if (!this.myConversation) {
            return;
        }
        if (this.private && this.private.id == this.myConversation) {
            //destroy private conversation
            this.destroyPrivateConversation();
        } else {
            //create new private conversation instance
            this.createPrivateConversation();
        }
        console.log("taken screen shot from my local video",this.captureVideoFrame());
    }
    async createPrivateConversation(){
        if(this.myConversation){
            axios.post(convertPath(`/conversation/${room.getName()}/${this.myConversation}/private`),{
                participant_id:room.myUserId(),
                guest_id: isElectron ? GUEST_ID : '',
                device_type: isElectron ? 'electron' : ''
            }, await electronConfig()).then(res=>{
                if(res.data && res.data.success){
                    this.private=new PrivateConversation(this.myConversation,room.myUserId());
                    this.private.start();
                    this.conversations[this.myConversation].setPrivate(true)
                    this.conversations[this.myConversation].made_private_by=room.myUserId();
                    this.updateMakePrivateButton(true);
                    this.sendPrivacyThumbnail(this.myConversation);
                }else{
                    console.error("Private conversation error",res.data);
                }
            }).catch(err=>{
                console.error("Failed to make conversation private",err);
            });

        }
    };
    async destroyPrivateConversation(){
        return new Promise(async (resolve,reject)=>{
                if(!this.private){resolve(true)}
                        console.log("destroying private space");
                        try {
                            let res=await axios.post(convertPath(`/conversation/${this.room_id}/${this.private.id}/private/end`),isElectron ? {
                                participant_id:this.myUserId,
                                guest_id: GUEST_ID,
                                device_type: 'electron'
                            } : {participant_id:this.myUserId},await electronConfig());
                            if(res.data && res.data.success){
                                let cid=res.data.conversation_id;
                                if(this.conversations[cid]){
                                    this.conversations[cid].setPrivate(false);
                                    this.conversations[cid].made_private_by=null;
                                }
                                if(this.private && this.private.id==res.data.conversation_id ){
                                    this.private.destroy()
                                }else{
                                    resolve(true);
                                }
                                this.private=undefined;
                                this.updateMakePrivateButton(false);
                                this.sendPrivacyThumbnail(cid,true);
                                resolve(true);
                            }else{
                                    console.error("Private conversation error",res.data);
                                    reject(res.data);
                            }
                        } catch (err) {
                            console.error("Failed to make conversation private",err);
                            reject(err);
                        }
        });
    };
    updateMakePrivateButton(isPrivate){
        console.error('update privacy button called',isPrivate);
        this.conversationBanner.find("#make-conversation-private").html(`<i class="fa fa-${isPrivate ? 'lock' : 'unlock'}"></i> ${isPrivate ? 'PRIVATE: ON' : 'PRIVATE: OFF'}`);
            this.conversationBanner.find("#make-conversation-private")
            .addClass(`btn-outline-${isPrivate ? 'success':'white'}`)
            .removeClass(`btn-outline-${isPrivate ? 'white':'success'}`);
        if(!permissions.hasPrivateSpaces()){
            // this.conversationBanner.find("#make-conversation-private").prop('disabled',true);
        }else{
            if(isPrivate){
                if(this.private.from_id==room.myUserId() || permissions.hasSpacesManager()){//card 529
                    this.conversationBanner.find("#make-conversation-private").removeAttr('disabled');
                }else{
                    this.conversationBanner.find("#make-conversation-private").prop('disabled',true);
                }
            }else{
                this.conversationBanner.find("#make-conversation-private").removeAttr('disabled');
            }
        }

    };
    privateConversationMessageHandler(message) {
        console.log("Private Spaces message",message);
        switch (message.action) {
            case "PrivacyChanged":
                if (message.conversation_id == this.myConversation) {
                    if (message.data.is_private) {
                        this.private = new PrivateConversation(
                            this.myConversation,
                            message.data.made_private_by ? message.data.made_private_by : message.data.from_id
                        );
                        this.private.startSilent(message.data);
                        this.updateMakePrivateButton(true);
                        this.sendPrivacyThumbnail(message.conversation_id);
                    } else {
                        if (this.private) {
                            this.private.destroySilent(message.data);
                            this.private = undefined;
                        }
                        this.updateMakePrivateButton(false);
                        this.sendPrivacyThumbnail(
                            message.conversation_id,
                            true
                        );
                    }
                }
                if (this.conversations[message.conversation_id]) {
                    this.conversations[message.conversation_id].setPrivate(message.data.is_private)
                    if (message.data.is_private) {
                        this.conversations[
                            message.conversation_id
                        ].made_private_by = message.data.made_private_by ? message.data.made_private_by : message.data.from_id;
                    } else {
                        this.conversations[
                            message.conversation_id
                        ].made_private_by = null;
                    }
                    this.conversations[message.conversation_id].participants.map(p=>{
                        try {
                            if(message.data.is_private && message.conversation_id != this.myConversation){
                               Video.videos[p.participant].onPrivateSpaceStarted();
                            }else{
                                Video.videos[p.participant].onPrivateSpaceEnded();
                            }
                        } catch (error) {

                        }
                    });
                }

                break;
            case "RequestAccepted":
                if (this.conversations[message.conversation_id]) {
                    this.joinSpace(message.conversation_id,false,message.data.token_id);
                }

                break;
            case "RequestRejected":
                this.showNotification("", "CONVERSATION_REQUEST_REJECTED", {
                    conversation_id: message.conversation_id,
                });
                break;
            case "ThumbnailUpdate":
                if (Video && Video.videos[message.data.participant]) {
                    if(message.data.thumbnail===true){
                        Video.videos[message.data.participant].thumbnail=this.defaultPrivateSpaceImage;
                    }else{
                        Video.videos[message.data.participant].thumbnail =
                            message.data.thumbnail;
                    }
                    this.updateThumbnailImage(message.data.participant);
                    this.updateConversationThumbnail(message.data.participant);
                }
                break;
            default:
                if (
                    message.conversation_id == this.myConversation &&
                    this.private
                ) {
                    this.private.handleMessage(message);
                }
                break;
        }
    }
    joinPrivateConversation(id, token, ignoreLock = false,overwriteMasterVolume=false) {
        try {
            if (this.myConversation == id) {
                this.setJoining(false); //card 758
                this.isJoining = false;
                return;
            }
            this.joinSpace(id,overwriteMasterVolume,token); //card 760
        } catch (error) {
            console.error("Failed to join private Space:", error);
            this.setJoining(false); //card 758
            this.isJoining = false;
        }
    }
    updateThumbnailImage(pid,forcePrivate=false) {
        try {
            if (Video.videos[pid]) {
                let cid = this.isOnConversation(pid);
                console.log(
                    "participant thumbnail update cid:" + cid + " My space",
                    this.myConversation
                );
                if (cid && cid != this.myConversation) {
                    if (Video.videos[pid].thumbnail || forcePrivate) {
                        if(!Video.videos[pid].thumbnail){
                            Video.videos[pid].thumbnail=this.defaultPrivateSpaceImage;
                        }
                        if (!Video.videos[pid].noVideoImage) {
                            Video.videos[pid].noVideoImage = new Image();
                            Video.videos[pid].noVideoImage.src =
                                Video.videos[pid].thumbnail;
                            Video.videos[pid].wrapper.append(
                                Video.videos[pid].noVideoImage
                            );
                        } else {
                            Video.videos[pid].noVideoImage.src =
                                Video.videos[pid].thumbnail;
                        }

                        Video.videos[pid].onPrivateSpaceStarted();

                    }else{
                        Video.videos[pid].onPrivateSpaceEnded();
                        if (Video.videos[pid].noVideoImage) {
                            Video.videos[pid].noVideoImage.remove();
                            Video.videos[pid].noVideoImage = undefined;
                        }

                    }
                } else {
                    Video.videos[pid].onPrivateSpaceEnded();
                    if (Video.videos[pid].noVideoImage) {
                        Video.videos[pid].noVideoImage.remove();
                        Video.videos[pid].noVideoImage = undefined;
                    }
                }
            }
        } catch (error) {
            console.error("update thumbnail image error", error);
        }
    }
    updateConversationThumbnail(pid,forcePrivate=false) {
        try {
            if (!Video || !Video.videos[pid]) {
                return;
            }
            Video.splitConversations.updatePrivacyThumbnail(pid); //card 760
            let cid = this.isOnConversation(pid);

            let participantBoxes = spacesView.spacesPanel.find(`.pid_${pid}`);
            if (cid == this.myConversation && Video.videos[pid].thumbnail) {
                $.each(participantBoxes, (i, box) => {
                    $(box).find(".no-video-thumbnail").remove();
                    $(box).find(".private-space-layer").addClass("d-none")
                    $("#sideBarVolumeRange").attr("disabled")
                    $(box).find("video").css("display", "block");
                    this.updateVideoStream(pid); //card 529
                    try {
                        $(box).find("video")[0].play()
                    } catch (error) {}
                });
                return;
            }
            console.log("participant boxes", participantBoxes);
            $.each(participantBoxes, (i, box) => {
                    if(!Video.videos[pid].thumbnail && forcePrivate){
                        Video.videos[pid].thumbnail=this.defaultPrivateSpaceImage;
                    }
                if (!Video.videos[pid].thumbnail) {
                    $(box).find(".no-video-thumbnail").remove();
                    $(box).find(".private-space-layer").addClass("d-none")
                    $("#sideBarVolumeRange").attr("disabled")
                    $(box).find("video").css("display", "block");
                    this.updateVideoStream(pid); //card 529
                    try {
                        $(box).find("video")[0].play()
                    } catch (error) {}
                    return;

                }
                let thumbnailExist = $(box).find(".no-video-thumbnail");
                if (thumbnailExist.length) {
                    thumbnailExist.attr("src", Video.videos[pid].thumbnail);
                } else {
                    let thumb = new Image();
                    thumb.src = Video.videos[pid].thumbnail;
                    thumb.classList.add("no-video-thumbnail");
                    $(box).find(".private-space-layer").removeClass("d-none")
                    $("#sideBarVolumeRange").attr("disabled")
                    $(box).find(".participant-container").append(thumb);
                    $(box).find("video").css("display", "none");
                    console.log("PID",pid);
                }
                try {
                    $(box).find("video")[0].pause()
                } catch (error) {}
            });
        } catch (error) {
            console.error("conversation thumbnail update", error);
        }
    }
    sendConversationJoinRequest(conversation_id) {
        try {
            //let data=JSON.stringify(message);
            let messageBody = {
                eventName: "PrivateConversation",
                action: "join_request",
                from_id: room.myUserId(),
                conversation_id: parseInt(conversation_id),
                data: {},
                room_id: room.getName(),
            };
            socket.connection.send(JSON.stringify(messageBody));
        } catch (error) {
            console.error("Send socket message error", error);
        }
    }

    sendPrivacyThumbnail(conversation_id, deleteThumb = false) {
        try {
            //let data=JSON.stringify(message);
            let messageBody = {
                eventName: "PrivateConversation",
                action: "PrivacyThumbnail",
                from_id: room.myUserId(),
                conversation_id: parseInt(conversation_id),
                data: {
                    thumbnail: deleteThumb ? false : this.captureVideoFrame(),
                },
                room_id: room.getName(),
            };
            socket.connection.send(JSON.stringify(messageBody));
        } catch (error) {
            console.error("Send socket message error", error);
        }
    }

    captureVideoFrame(pid = "me") {
        if (!Video || !room) return null;
        let videoEl;
        if (Video.videos[pid]) {
            videoEl = document.getElementById(`${pid}-media-player`);
        }
        if (pid == room.myUserId() || pid == "me") {
            if(isCameraMuted()){
                return this.defaultPrivateSpaceImage;
            }
            videoEl = document.getElementById("localVideo1");
        }
        if (videoEl) {
            var canvas = document.createElement("canvas");
            let videoW = videoEl.videoWidth;
            let videoH = videoEl.videoHeight;
            canvas.width = 320;
            canvas.height = 180;
            var scale = Math.min(canvas.width / videoW, canvas.height / videoH);
            // get the top left position of the image
            var x = canvas.width / 2 - (videoW / 2) * scale;
            var y = canvas.height / 2 - (videoH / 2) * scale;
            var ctx = canvas.getContext("2d");
            //ctx.fillRect(0,0,videoW,videoH);
            ctx.filter = "blur(15px)";
            ctx.drawImage(videoEl, x, y, videoW * scale, videoH * scale);
            return canvas.toDataURL("image/jpeg", 0.5);
        }
        return null;
    }
    //end code card ID: 529
    //begin card 599
    startConversationPlayers() {
        let videos = spacesView.spacesView.find("video");
        if (videos.length > 0) {
            $.each(videos, function (i, video) {
                let pid = video.getAttribute("pid");
                let p=kinoParticipants.get(pid);
                if(p){
                    let vtrack=p.getVideo();
                    if (vtrack) {
                        video.srcObject = vtrack.stream;
                    }
                }
            });
        }
    }
    //end card 599

    setJoining(isJoining, id, message = null) {
        if (!isJoining) {
            $("#joining-space-notification-top").remove();
            this.userSpaceStatusChanged('joined');
            return;
        }
        var c = this;
        c.userJoiningSpace(id, false);
        $("#joining-space-notification-top").remove();
        let text = "";
        let closediv = $("<div/>", {
            class: "close",
            html: `<i class="icofont-close icofont-1x"></i>`,
        });
        if (!message) {
            return;
            if (c.conversations[id]) {
                text = `Joining ${
                    c.conversations[id].is_private ? "private" : ""
                } space ${c.conversations[id].name}`;
            } else {
                text = `Joining space`;
            }
        } else {
            text = `${message}`;
        }
        let textdiv = $("<div/>", {
            class: "text",
            html: [text],
        });
        let container = $("<div/>", {
            class: `notificationContent joining-space-notification`,
            id: `joining-space-notification-top`,
            html: [textdiv, closediv],
        });

        let timeout = setTimeout(function () {
            $("#joining-space-notification-top").remove();
        }, 10000);
        closediv.on("click", function (e) {
            if (typeof timeout !== "undefined") {
                clearTimeout(timeout);
            }
            $("#joining-space-notification-top").remove();
        });
        container.prependTo(Video.notifications);
    };
    //end card 758

    //fix socket disconnect while on private space
    storeCurrentState(){
        try {
           this.storedState={
                myConversation:this.myConversation,
                private:this.private
            };
        } catch (error) {}
    }

    userJoiningSpace(space_id, userJoinedId){
        let c = this;
        // console.error('USER JOIN IS BEING CALLED: ')
        try{
            if(c.conversations[space_id].participants){
                c.conversations[space_id].participants.forEach((p) => {
                    room.sendEndpointMessage(p.participant, {
                        is_joining_space_message: 'joining_a_space',
                        data:{
                            space_id: space_id,
                            user_joined_id: userJoinedId
                        }
                    });
                });
            }
        }catch(err){}
    }

    userJoiningSpaceHandler(message, user){
        let c = this;
        // console.log("message: ", message, " user: ", user);
        // console.log("USER IS JOINING SPACE EVENT: ",c.conversations[message.data.space_id].participants);
        let name = user.getDisplayName();
        let id = user.getId();
        try{
            if(!message.data.user_joined_id){
                if(c.myConversation == message.data.space_id){
                    Video.showNotification(null, `${name} is joining to this space`, 'joining_a_space_warning', id);
                }
                return;
            }
            if($(`#joining_a_space_warning-${id}`)){
                setTimeout(() => {
                    $(`#joining_a_space_warning-${id}`).remove();
                },1000)
            };
        }catch(err){
            console.error('No spaces found ', err);
        }

    }

    notifyOtherParticipants(space_id, userInvited, userInvitedId){
        let c = this;
        console.error(space_id);
        if(c.conversations[space_id].participants){
            c.conversations[space_id].participants.forEach((p) => {
                room.sendEndpointMessage(p.participant, {
                    notify_other_participants_message: 'notify_other_participants',
                    data: {
                        space_id: space_id,
                        user_invited: userInvited,
                        user_invited_id: userInvitedId
                    }
                });
            });
        }
    }

    notifyOtherParticipantsHandler(message, user){
        let c = this;
        // console.error('MESSAGE: ', message, ' USER: ', user);
        let name = user.getDisplayName();
        let userInvited = message.data.user_invited;
        let userInvitedId = message.data.user_invited_id;
        try{
            if(c.myConversation == message.data.space_id){
                Video.showNotification(null, `${name} invited ${userInvited} to this space`, 'joining_a_space_warning', userInvitedId);
            }
        }catch(err){}
    }

    splitUnderwayOverlay (username,message=null) {
        var c = this;
        let reconnectingAnimation = $('<div/>',{
            class: 'loadingOverlayAnimation',
            html: [c.loadingCircle],
        });
        let text='';
        if(message){
            text = message;
        }else{
            text = username == "You" ? `Moving to space` : `${username} is moving you to a space`;
        }
        let reconnectionSubText = $('<div/>',{
            class: 'loadingOverlayText',
            html: text,
        });

        let reconnectionText = $('<div/>',{
            class: 'loadingOverlayText',
            html: 'Please wait...',
        });

        let reconnectionInnerCont = $('<div/>',{
            class: 'loadingOverlayInner',
            html: [reconnectingAnimation, reconnectionText, reconnectionSubText],
        });

        c.splitUnderWayLayer = $('<div/>',{
            class: 'loadingOverlay',
            id: 'splitUnderwayOverlay',
            html: reconnectionInnerCont,
        });
        if($(".loadingOverlay")){
            if(!$(".loadingOverlay").hasClass("joiningTheKinoOverlay")){
                $(".loadingOverlay").remove();
            }
        }
        $('#app').append(c.splitUnderWayLayer);
        c.removeSplitUnderWayOverlay();
    };

    removeSplitUnderWayOverlay(){
        let timeout = null;
        try {
            timeout = setTimeout(()=>{
                $(".loadingOverlay").remove();
            },4000)
        } catch (e) {}
    }
    removeJoiningOverlayNow(){
        setTimeout(() => {
          $(".loadingOverlay").remove();
        }, 500);

    };

    userSpaceStatusChanged(joinStatus,username=null){
        switch (joinStatus) {
            case "joining":
                this.splitUnderwayOverlay(username,username == null ? "Joining space" : null);
                break;
            case "joining_last_space":
                    this.splitUnderwayOverlay(username,"Joining previous space");
                break;
            case "waiting":
                //we wanna leave removeSplitUnderWayOverlay timeout to end
                break;
            case "leaving":
                this.splitUnderwayOverlay(username,username == null ? "Leaving space" : null);
                break;
            case "users_moving":
                // this.splitUnderwayOverlay(username,"Moving to spaces");
                break;
            default:
                this.removeJoiningOverlayNow();
                break;
        }
    };

    userJoiningPrivateSpace(space_id, userRequestId){
        let c = this;
        try{
            if(c.conversations[space_id].participants){
                c.conversations[space_id].participants.forEach((p) => {
                    room.sendEndpointMessage(p.participant, {
                        message: 'accepted_or_rejected_private_space',
                        data:{
                            space_id: space_id,
                            user_request_id: userRequestId
                        }
                    });
                });
            }
        }catch(err){}
    }

    userJoiningPrivateSpaceHandler(message, user){
        let user_id = message.data.user_request_id;
        if($(`#${user_id}-private-notification`)){
            $(`#${user_id}-private-notification`).remove();
        }
    }

    storeLastSpaceId(id,spacePrivate=false){
        if(!id){
            localStorage.setItem('last_space','');
        }else{
            localStorage.setItem('last_space',JSON.stringify({id:id,is_private:spacePrivate}));
        }
    };

    getLastSpaceId(){
        const lastSpace = localStorage.getItem('last_space')
        return lastSpace ? JSON.parse(lastSpace) : null;
    };

    getThumbnail(space_id,pid){
        let c=this;
        console.log("get humbnail for ",pid)
        axios.get(convertPath(`/conversation/${room.getName()}/${space_id}/${pid}`)).then(res=>{
            if(res.data && res.data.thumb){
            let msg={
                eventName:"PrivateConversation",
                conversation_id:space_id,
                action:"ThumbnailUpdate",
                data:{
                    thumbnail:res.data.thumb,
                    participant:pid
                }
            };
                c.privateConversationMessageHandler(msg);
            }
        }).catch(err=>{
            console.error(err);
        });
    }

    sendRemoveJoiningLayer(){
        try {

            room.broadcastEndpointMessage({
                message: 'remove_join_layer',
                data: {
                    participant: room.myUserId(),
                }
            })
        } catch (error) {

        }
    }

    removeJoiningLayerHandler(message){
        let data = message.data;
        animatedLayers.removeIsJoiningLayer(data.participant);
    }

    /**
     * new spaces functions
     */
    emptyAllSpaces(){
        for (const space_id in this.conversations) {
            this.conversations[space_id].clearParticipants();
            this.conversations[space_id].renderSpaceTiles();
        }
    };
    leaveSpace(switchToSpace=false,overwriteVolume=false,silently=false){
        return new Promise(async (resolve,reject)=>{
            try {
                if(!this.myConversation){
                    resolve(true);
                    return;
                }
                muteAll.setMuteAllState(false);
                if(switchToSpace){
                    this.userSpaceStatusChanged('leaving');
                    if(Video.presenter.isPresenterView){
                        Video.presenter.removePresenter(true);
                    }
                }else{
                    if(spacesView.isOpen()){
                        spacesView.hideSpaceView();
                    }
                }
                this.storeLastSpaceId('');
                console.trace("leaving my space",this.myConversation)
                $(`#notificationsBanner`).find(".CONVERSATION_MADE_NOT_PRIVATE").remove();
                let space_id=this.myConversation;
                this.leaving=true;
                //send socket message that user left space

                let me=kinoParticipants.me();
                console.log("my participant",me);
                let leftSpace=this.getSpace(space_id);
                if(leftSpace.isPrivate()){

                    console.log("Private conversation object",this.private);
                    if(this.private && this.private.from_id == this.myUserId){
                        //begin card 760
                        try {
                            await this.destroyPrivateConversation();
                        } catch (error) {}
                        //end card 760
                    }else if(this.private){
                        this.private.stopSendingStreamsPrivate();
                        this.sendPrivacyThumbnail(leftSpace.id,true);
                        this.private=undefined;
                        this.updateMakePrivateButton(false);
                    }
                    this.myConversation=null;
                    leftSpace.participants.forEach((pid) => {
                        if (Video.videos[pid]) {
                            console.log("Participant in private space", Video.videos[pid]);
                            this.updateThumbnailImage(pid);
                            this.updateConversationThumbnail(pid);
                        }
                    });
                }

                this.myConversation=null;
                leftSpace.participantLeft(me.id);
                kinoParticipants.addAllInSideScreen();
                socket.spaceLeftMessage(space_id,silently);
                if(!switchToSpace){
                    muteAll.checkMuteAllPolicy();
                    muteAll.onUserSpaceChanged();
                    console.log("Kino Participants",kinoParticipants.getParticipants());
                    kinoParticipants.moveNonSpaceToMain();
                    screenShare.popup.loadAllVideos();
                    pictureInPicture.updateUsers(kinoParticipants.inSameSpace());
                    Video.enableLobbyView();
                    emitSpaceChanged(room.myUserId(),null,space_id)
                    this.userSpaceStatusChanged('left');

                }
                this.leaving=false;
                resolve(true);
                this.hideBannerInfo();
            } catch (error) {
                this.userSpaceStatusChanged('left');
                this.leaving=false;
                console.error("error leaving space",error);
                reject(error);
            }
        });
    };

    joinSpace(space_id,overwriteVolume=false,private_token=false){
        //check if on stage is active
        if(onStage.isActive()){
            onStage.showLockOnStageActiveNotification();
            return;
        }
        return new Promise((resolve,reject)=>{
            if(space_id==this.myConversation){
                resolve(true);
                CONV_STORAGE.updateBanner();
                CONV_STORAGE.showBanner();
                return;
            }
            if(spacesView.isOpen()){
                spacesView.hideSpaceView();
            }
            muteAll.setMuteAllState(false);
            const oldSpaceId = this.myConversation;
            this.hideBannerInfo();
            // if(Object.keys(Video.videos).length==0 && Video.stealFocus.focusedOnMe){
            //     Video.stealFocus.sendReleaseFocusCommand();
            //     Video.showNotification(Video.stealFocus.focusedIconNotification,'On stage is deactivated','stealFocusNotification',room.myUserId());
            // }
            // this.conversationBanner.removeClass("hiddenImportant hiddenAnimated");
            this.conversationBanner.removeClass("hiddenImportant");
            this.userSpaceStatusChanged('joining');
            this.leaveSpace(space_id,overwriteVolume).then(()=>{
                console.warn(`JOINING SPACE ${space_id} with overwriteVolume=${overwriteVolume}`);
                let space=this.getSpace(space_id);
                   if(space){
                        if(Video.presenter.isPresenterView){
                            Video.presenter.removePresenter(true);
                        }
                        this.unFocusNonConvo(space.participants);
                        if(!space.isPrivate()){
                            this.performJoin(space,overwriteVolume,private_token);
                            this.userSpaceStatusChanged('joined');
                            emitSpaceChanged(room.myUserId(),space_id,oldSpaceId)
                            resolve("joined");
                        }else{
                            if(!private_token && permissions.shouldRequestToJoinPrivateSpace() && (space.id!=permissions.initialSpace())){
                                this.userSpaceStatusChanged('joined');
                                reject(`Access denied ${space_id} is private`);
                                return;
                            }

                            this.getModeratorToken(space.id,private_token).then(token=>{
                                this.performJoin(space,overwriteVolume,token);
                                this.userSpaceStatusChanged('joined');
                                emitSpaceChanged(room.myUserId(),space_id,oldSpaceId)
                                resolve("joined");
                            }).catch(err=>{
                                this.userSpaceStatusChanged('joined');
                                reject(err);
                            });
                        }
                        onStage.renderOnstageButtons();
                   }else{
                       this.userSpaceStatusChanged('joined');
                       reject(`Space ${space_id} does not exist`)
                   }
            }).catch(err=>{
                this.userSpaceStatusChanged('joined');
                reject(err);
            });
        });
    };

    performJoin(space,overwriteVolume,token){
        console.log("Sending SpaceJoined message for space",space.id);
        socket.spaceJoinedMessage(space.id,token);
        console.log("Calling participantJoined");
        space.participantJoined(room.myUserId());
        screenShare.popup.loadAllVideos();
        pictureInPicture.updateUsers(kinoParticipants.inSameSpace());
        try {
            if (space.isPrivate()) {
                this.private = new PrivateConversation(
                    space.id,
                    space.made_private_by
                );
                this.private.sendPrivateStreamIds();
                this.updateMakePrivateButton(true);
                this.sendPrivacyThumbnail(space.id);
            } else {
                if (this.private) {
                    this.private.stopSendingStreamsPrivate();

                    this.private = undefined;
                    this.sendPrivacyThumbnail(space.id, true);
                }
                this.updateMakePrivateButton(false);
            }
        } catch (error) {
            console.log("error clearig private conversation", error);
        }
    };

    getSpace(id){
        return this.conversations[id];
    }

    showInviteToSpace(pid){
        try {
            let p=kinoParticipants.get(pid);
            if(p){
                this.showNotification(Video.conversationIcon,'INVITE_TO_NEW_SPACE',{
                    participant:p.id,
                    displayName:p.getName()
                });
            }
        } catch (error) {

        }
    };
    showInviteOrLeave(pid){
        try {
            let p=kinoParticipants.get(pid);
            if(p){
                this.showNotification(Video.conversationIcon,'INVITE_OR_LEAVE',{
                    participant:p.id,
                    displayName:p.getName()
                });
            }
        } catch (error) {

        }
    }
    spaceExists(id){
        return this.conversations.hasOwnProperty(id);
    }
};
